export const Learnsets: import('../../../sim/dex-species').ModdedLearnsetDataTable = {
	pichu: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bide: ["3E"],
			charge: ["3E"],
			charm: ["3L1"],
			doubleslap: ["3E"],
			doubleteam: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3E"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sweetkiss: ["3L11"],
			tailwhip: ["3L6"],
			teeterdance: ["3S0"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thundershock: ["3L1"],
			thunderwave: ["3L8"],
			toxic: ["3M"],
			wish: ["3S1"],
		},
	},
	pikachu: {
		inherit: true,
		learnset: {
			agility: ["3L33"],
			attract: ["3M"],
			brickbreak: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M", "3L15"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1", "3S10"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M", "3L50"],
			protect: ["3M"],
			quickattack: ["3L11"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			slam: ["3L20"],
			strength: ["3M"],
			tailwhip: ["3L6", "3S10"],
			thunder: ["3M", "3L41"],
			thunderbolt: ["3M", "3L26"],
			thundershock: ["3L1", "3S10"],
			thunderwave: ["3L8", "3S10"],
			toxic: ["3M"],
		},
	},
	raichu: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			brickbreak: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			protect: ["3M"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			strength: ["3M"],
			tailwhip: ["3L1"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M", "3L1"],
			thundershock: ["3L1"],
			toxic: ["3M"],
		},
	},
	sandshrew: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			brickbreak: ["3M"],
			counter: ["3E"],
			crushclaw: ["3E"],
			cut: ["3M"],
			defensecurl: ["3L6"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flail: ["3E"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L37"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			poisonsting: ["3L17"],
			protect: ["3M"],
			rapidspin: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3E"],
			sandattack: ["3L11"],
			sandstorm: ["3M", "3L53"],
			sandtomb: ["3L45"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			slash: ["3L23"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swift: ["3L30"],
			swordsdance: ["3E"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	sandslash: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			brickbreak: ["3M"],
			cut: ["3M"],
			defensecurl: ["3L1"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L42"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			poisonsting: ["3L17"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L1"],
			sandstorm: ["3M", "3L62"],
			sandtomb: ["3L52"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			slash: ["3L24"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swift: ["3L33"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	vulpix: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			confuseray: ["3L21"],
			dig: ["3M"],
			disable: ["3E"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			feintattack: ["3E"],
			fireblast: ["3M"],
			firespin: ["3L41"],
			flail: ["3E"],
			flamethrower: ["3M", "3L29"],
			frustration: ["3M"],
			grudge: ["3L37"],
			heatwave: ["3E"],
			hiddenpower: ["3M"],
			howl: ["3E"],
			hypnosis: ["3E"],
			imprison: ["3L25"],
			irontail: ["3M"],
			overheat: ["3M"],
			protect: ["3M"],
			psychup: ["3E"],
			quickattack: ["3L13"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L9"],
			safeguard: ["3M", "3L33"],
			secretpower: ["3M"],
			spite: ["3E"],
			sunnyday: ["3M"],
			tailwhip: ["3L5"],
			toxic: ["3M"],
			willowisp: ["3L17"],
		},
	},
	ninetales: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			confuseray: ["3L1"],
			dig: ["3M"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L45"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			overheat: ["3M"],
			protect: ["3M"],
			quickattack: ["3L1"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			safeguard: ["3M", "3L1"],
			secretpower: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	igglybuff: {
		learnset: {
			attract: ["3M"],
			charm: ["3L1"],
			defensecurl: ["3L4"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			faketears: ["3E"],
			feintattack: ["3E"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			lightscreen: ["3M"],
			pound: ["3L9"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L1"],
			solarbeam: ["3M"],
			sunnyday: ["3M"],
			sweetkiss: ["3L14"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wish: ["3E"],
		},
	},
	jigglypuff: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3L34"],
			brickbreak: ["3M"],
			defensecurl: ["3L4"],
			dig: ["3M"],
			disable: ["3L14"],
			doubleedge: ["3L49"],
			doubleslap: ["3L24"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hypervoice: ["3L44"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			mimic: ["3L39"],
			pound: ["3L9"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M", "3L29"],
			return: ["3M"],
			rollout: ["3L19"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L1"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	wigglytuff: {
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			defensecurl: ["3L1"],
			dig: ["3M"],
			disable: ["3L1"],
			doubleslap: ["3L1"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L1"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	zubat: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			aircutter: ["3L31"],
			astonish: ["3L6"],
			attract: ["3M"],
			bite: ["3L16"],
			confuseray: ["3L26"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			gust: ["3E"],
			haze: ["3L46"],
			hiddenpower: ["3M"],
			leechlife: ["3L1"],
			meanlook: ["3L36"],
			poisonfang: ["3L41"],
			protect: ["3M"],
			pursuit: ["3E"],
			quickattack: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			supersonic: ["3L6"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			wingattack: ["3L21"],
		},
	},
	golbat: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			aircutter: ["3L35"],
			astonish: ["3L1"],
			attract: ["3M"],
			bite: ["3L16"],
			confuseray: ["3L28"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			haze: ["3L56"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechlife: ["3L1"],
			meanlook: ["3L42"],
			poisonfang: ["3L49"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			supersonic: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			wingattack: ["3L21"],
		},
	},
	crobat: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			aircutter: ["3L35"],
			astonish: ["3L1"],
			attract: ["3M"],
			bite: ["3L16"],
			confuseray: ["3L28"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			haze: ["3L56"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechlife: ["3L1"],
			meanlook: ["3L42"],
			poisonfang: ["3L49"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			supersonic: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			wingattack: ["3L21"],
		},
	},
	oddish: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			acid: ["3L23"],
			attract: ["3M"],
			bulletseed: ["3M"],
			charm: ["3E"],
			cut: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3E"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			ingrain: ["3E"],
			moonlight: ["3L32"],
			petaldance: ["3L39"],
			poisonpowder: ["3L14"],
			protect: ["3M"],
			razorleaf: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L18"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L16"],
			sunnyday: ["3M"],
			sweetscent: ["3L7"],
			synthesis: ["3E"],
			toxic: ["3M"],
		},
	},
	gloom: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			acid: ["3L24"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			moonlight: ["3L35"],
			petaldance: ["3L44"],
			poisonpowder: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sleeppowder: ["3L18"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L16"],
			sunnyday: ["3M"],
			sweetscent: ["3L1"],
			toxic: ["3M"],
		},
	},
	vileplume: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			aromatherapy: ["3L1"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			megadrain: ["3L1"],
			petaldance: ["3L44"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			stunspore: ["3L1"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	bellossom: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			magicalleaf: ["3L1"],
			petaldance: ["3L44"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M", "3L55"],
			stunspore: ["3L1"],
			sunnyday: ["3M"],
			sweetscent: ["3L1"],
			toxic: ["3M"],
		},
	},
	psyduck: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L16"],
			dig: ["3M"],
			disable: ["3L10"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			foresight: ["3E"],
			frustration: ["3M"],
			furyswipes: ["3L40"],
			futuresight: ["3E"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L50"],
			hypnosis: ["3E"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3E"],
			protect: ["3M"],
			psybeam: ["3E"],
			psychic: ["3E"],
			psychup: ["3L31"],
			raindance: ["3M"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			screech: ["3L23"],
			secretpower: ["3M"],
			strength: ["3M"],
			surf: ["3M"],
			tailwhip: ["3L5"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
		},
	},
	golduck: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L16"],
			dig: ["3M"],
			disable: ["3L1"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L44"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L58"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			protect: ["3M"],
			psychup: ["3L31"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			screech: ["3L23"],
			secretpower: ["3M"],
			strength: ["3M"],
			surf: ["3M"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
		},
	},
	abra: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			calmmind: ["3M"],
			doubleteam: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			firepunch: ["3E"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			icepunch: ["3E"],
			irontail: ["3M"],
			knockoff: ["3E"],
			lightscreen: ["3M"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L1"],
			thief: ["3M"],
			thunderpunch: ["3E"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	kadabra: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L1"],
			disable: ["3L18"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L30"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			kinesis: ["3L1"],
			lightscreen: ["3M"],
			protect: ["3M"],
			psybeam: ["3L21"],
			psychic: ["3M", "3L36"],
			raindance: ["3M"],
			recover: ["3L25"],
			reflect: ["3M", "3L23"],
			rest: ["3M"],
			return: ["3M"],
			roleplay: ["3L33"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L1"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			trick: ["3L43"],
		},
	},
	alakazam: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			calmmind: ["3M", "3L33"],
			confusion: ["3L1"],
			disable: ["3L18"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L30"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			kinesis: ["3L1"],
			lightscreen: ["3M"],
			protect: ["3M"],
			psybeam: ["3L21"],
			psychic: ["3M", "3L36"],
			raindance: ["3M"],
			recover: ["3L25"],
			reflect: ["3M", "3L23"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L1"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			trick: ["3L43"],
		},
	},
	machop: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3E"],
			crosschop: ["3L40"],
			dig: ["3M"],
			doubleteam: ["3M"],
			dynamicpunch: ["3L49"],
			earthquake: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L7"],
			focuspunch: ["3M"],
			foresight: ["3L22"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			karatechop: ["3L13"],
			leer: ["3L1"],
			lightscreen: ["3E"],
			lowkick: ["3L1"],
			meditate: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L25"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L43"],
			secretpower: ["3M"],
			seismictoss: ["3L19"],
			smellingsalts: ["3E"],
			strength: ["3M"],
			submission: ["3L37"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			vitalthrow: ["3L31"],
		},
	},
	machoke: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			crosschop: ["3L46"],
			dig: ["3M"],
			doubleteam: ["3M"],
			dynamicpunch: ["3L59"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			foresight: ["3L22"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			karatechop: ["3L13"],
			leer: ["3L1"],
			lowkick: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L25"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L51"],
			secretpower: ["3M"],
			seismictoss: ["3L19"],
			strength: ["3M"],
			submission: ["3L41"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			vitalthrow: ["3L33"],
		},
	},
	machamp: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			crosschop: ["3L46"],
			dig: ["3M"],
			doubleteam: ["3M"],
			dynamicpunch: ["3L59"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			foresight: ["3L22"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			karatechop: ["3L13"],
			leer: ["3L1"],
			lowkick: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L25"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L51"],
			secretpower: ["3M"],
			seismictoss: ["3L19"],
			strength: ["3M"],
			submission: ["3L41"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			vitalthrow: ["3L33"],
		},
	},
	tentacool: {
		inherit: true,
		learnset: {
			acid: ["3L19"],
			attract: ["3M"],
			barrier: ["3L36"],
			blizzard: ["3M"],
			bubblebeam: ["3L25"],
			confuseray: ["3E"],
			constrict: ["3L12"],
			cut: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L49"],
			icebeam: ["3M"],
			mirrorcoat: ["3E"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3E"],
			screech: ["3L43"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			supersonic: ["3L6"],
			surf: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			wrap: ["3L30"],
		},
	},
	tentacruel: {
		inherit: true,
		learnset: {
			acid: ["3L19"],
			attract: ["3M"],
			barrier: ["3L38"],
			blizzard: ["3M"],
			bubblebeam: ["3L25"],
			constrict: ["3L1"],
			cut: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L55"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L47"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			supersonic: ["3L1"],
			surf: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			wrap: ["3L30"],
		},
	},
	geodude: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			block: ["3E"],
			brickbreak: ["3M"],
			defensecurl: ["3L1"],
			dig: ["3M"],
			doubleedge: ["3L46"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L36"],
			explosion: ["3L41"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			magnitude: ["3L16"],
			mudsport: ["3L6"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockblast: ["3L31"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rockthrow: ["3L11"],
			rocktomb: ["3M"],
			rollout: ["3L26"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			selfdestruct: ["3L21"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
		},
	},
	graveler: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			brickbreak: ["3M"],
			defensecurl: ["3L1"],
			dig: ["3M"],
			doubleedge: ["3L62"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L45"],
			explosion: ["3L53"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			magnitude: ["3L16"],
			mudsport: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockblast: ["3L37"],
			rocksmash: ["3M"],
			rockthrow: ["3L1"],
			rocktomb: ["3M"],
			rollout: ["3L29"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			selfdestruct: ["3L21"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
		},
	},
	golem: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			brickbreak: ["3M"],
			defensecurl: ["3L1"],
			dig: ["3M"],
			doubleedge: ["3L62"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L45"],
			explosion: ["3L53"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			magnitude: ["3L16"],
			mudsport: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockblast: ["3L37"],
			rocksmash: ["3M"],
			rockthrow: ["3L1"],
			rocktomb: ["3M"],
			rollout: ["3L29"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			selfdestruct: ["3L21"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
		},
	},
	magnemite: {
		inherit: true,
		learnset: {
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			lockon: ["3L32"],
			metalsound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L44"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sonicboom: ["3L16"],
			spark: ["3L26"],
			sunnyday: ["3M"],
			supersonic: ["3L11"],
			swift: ["3L38"],
			tackle: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thundershock: ["3L6"],
			thunderwave: ["3L21"],
			toxic: ["3M"],
			zapcannon: ["3L50"],
		},
	},
	magneton: {
		inherit: true,
		learnset: {
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lockon: ["3L35"],
			metalsound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L53"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sonicboom: ["3L16"],
			spark: ["3L26"],
			sunnyday: ["3M"],
			supersonic: ["3L1"],
			tackle: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thundershock: ["3L1"],
			thunderwave: ["3L21"],
			toxic: ["3M"],
			triattack: ["3L44"],
			zapcannon: ["3L62"],
		},
	},
	doduo: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			agility: ["3L45"],
			attract: ["3M"],
			doubleteam: ["3M"],
			drillpeck: ["3L37"],
			endeavor: ["3E"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L13"],
			growl: ["3L1"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L9"],
			quickattack: ["3E"],
			rage: ["3L25"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			supersonic: ["3E"],
			thief: ["3M"],
			toxic: ["3M"],
			triattack: ["3L21"],
			uproar: ["3L33"],
		},
	},
	dodrio: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			agility: ["3L60"],
			attract: ["3M"],
			doubleteam: ["3M"],
			drillpeck: ["3L47"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L1"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L1"],
			rage: ["3L25"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			triattack: ["3L21"],
			uproar: ["3L38"],
		},
	},
	grimer: {
		inherit: true,
		learnset: {
			acidarmor: ["3L34"],
			attract: ["3M"],
			curse: ["3E"],
			dig: ["3M"],
			disable: ["3L8"],
			doubleteam: ["3M"],
			explosion: ["3E"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			harden: ["3L4"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			imprison: ["3E"],
			meanlook: ["3E"],
			memento: ["3L53"],
			minimize: ["3L19"],
			poisongas: ["3L1"],
			pound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocktomb: ["3M"],
			screech: ["3L26"],
			secretpower: ["3M"],
			shadowpunch: ["3E"],
			shockwave: ["3M"],
			sludge: ["3L13"],
			sludgebomb: ["3M", "3L43"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	muk: {
		inherit: true,
		learnset: {
			acidarmor: ["3L34"],
			attract: ["3M"],
			brickbreak: ["3M"],
			dig: ["3M"],
			disable: ["3L8"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			memento: ["3L61"],
			minimize: ["3L19"],
			poisongas: ["3L1"],
			pound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			screech: ["3L26"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			sludge: ["3L13"],
			sludgebomb: ["3M", "3L47"],
			strength: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	voltorb: {
		inherit: true,
		learnset: {
			charge: ["3L1"],
			doubleteam: ["3M"],
			explosion: ["3L46"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			lightscreen: ["3M", "3L37"],
			mirrorcoat: ["3L49"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rollout: ["3L32"],
			screech: ["3L8"],
			secretpower: ["3M"],
			selfdestruct: ["3L27"],
			shockwave: ["3M"],
			sonicboom: ["3L15"],
			spark: ["3L21"],
			swift: ["3L42"],
			tackle: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	electrode: {
		inherit: true,
		learnset: {
			charge: ["3L1"],
			doubleteam: ["3M"],
			explosion: ["3L54"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M", "3L41"],
			mirrorcoat: ["3L59"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rollout: ["3L34"],
			screech: ["3L1"],
			secretpower: ["3M"],
			selfdestruct: ["3L27"],
			shockwave: ["3M"],
			sonicboom: ["3L1"],
			spark: ["3L21"],
			swift: ["3L48"],
			tackle: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	koffing: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			destinybond: ["3L45", "3E"],
			doubleteam: ["3M"],
			explosion: ["3L41"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			haze: ["3L33"],
			hiddenpower: ["3M"],
			memento: ["3L49"],
			poisongas: ["3L1"],
			protect: ["3M"],
			psywave: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			selfdestruct: ["3L17"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sludge: ["3L21"],
			sludgebomb: ["3M"],
			smog: ["3L9"],
			smokescreen: ["3L25"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			willowisp: ["3E"],
		},
	},
	weezing: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			destinybond: ["3L51"],
			doubleteam: ["3M"],
			explosion: ["3L44"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			haze: ["3L33"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			memento: ["3L58"],
			poisongas: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			selfdestruct: ["3L1"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sludge: ["3L21"],
			sludgebomb: ["3M"],
			smog: ["3L1"],
			smokescreen: ["3L25"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	rhyhorn: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			counter: ["3E"],
			crunch: ["3E"],
			crushclaw: ["3E"],
			curse: ["3E"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L52"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L15"],
			hiddenpower: ["3M"],
			hornattack: ["3L1"],
			horndrill: ["3L38"],
			icebeam: ["3M"],
			irontail: ["3M"],
			magnitude: ["3E"],
			megahorn: ["3L57"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3E"],
			roar: ["3M"],
			rockblast: ["3L29"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L24"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			stomp: ["3L10"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swordsdance: ["3E"],
			tailwhip: ["3L1"],
			takedown: ["3L43"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
		},
	},
	rhydon: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L58"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L1"],
			hiddenpower: ["3M"],
			hornattack: ["3L1"],
			horndrill: ["3L38"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			megahorn: ["3L66"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockblast: ["3L29"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L24"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			stomp: ["3L1"],
			strength: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tailwhip: ["3L1"],
			takedown: ["3L46"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
		},
	},
	horsea: {
		inherit: true,
		learnset: {
			agility: ["3L36"],
			attract: ["3M"],
			aurorabeam: ["3E"],
			blizzard: ["3M"],
			bubble: ["3L1"],
			disable: ["3E"],
			dive: ["3M"],
			doubleteam: ["3M"],
			dragonbreath: ["3E"],
			dragondance: ["3L50"],
			dragonrage: ["3E"],
			facade: ["3M"],
			flail: ["3E"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L43"],
			icebeam: ["3M"],
			leer: ["3L15"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			smokescreen: ["3L8"],
			splash: ["3E"],
			surf: ["3M"],
			toxic: ["3M"],
			twister: ["3L29"],
			waterfall: ["3M"],
			watergun: ["3L22"],
			waterpulse: ["3M"],
		},
	},
	seadra: {
		inherit: true,
		learnset: {
			agility: ["3L40"],
			attract: ["3M"],
			blizzard: ["3M"],
			bubble: ["3L1"],
			dive: ["3M"],
			doubleteam: ["3M"],
			dragondance: ["3L62"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L51"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			leer: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			smokescreen: ["3L1"],
			surf: ["3M"],
			toxic: ["3M"],
			twister: ["3L29"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	kingdra: {
		inherit: true,
		learnset: {
			agility: ["3L40"],
			attract: ["3M"],
			blizzard: ["3M"],
			bubble: ["3L1"],
			dive: ["3M"],
			doubleteam: ["3M"],
			dragondance: ["3L62"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L51"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			leer: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			smokescreen: ["3L1"],
			surf: ["3M"],
			toxic: ["3M"],
			twister: ["3L29"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	goldeen: {
		inherit: true,
		learnset: {
			agility: ["3L52"],
			attract: ["3M"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L24"],
			frustration: ["3M"],
			furyattack: ["3L29"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hornattack: ["3L15"],
			horndrill: ["3L43"],
			hydropump: ["3E"],
			icebeam: ["3M"],
			mudsport: ["3E"],
			peck: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sleeptalk: ["3E"],
			supersonic: ["3L10"],
			surf: ["3M"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M", "3L38"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
		},
	},
	seaking: {
		inherit: true,
		learnset: {
			agility: ["3L61"],
			attract: ["3M"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L24"],
			frustration: ["3M"],
			furyattack: ["3L29"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hornattack: ["3L15"],
			horndrill: ["3L49"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			peck: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			supersonic: ["3L1"],
			surf: ["3M"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M", "3L41"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
		},
	},
	staryu: {
		inherit: true,
		learnset: {
			blizzard: ["3M"],
			bubblebeam: ["3L28"],
			camouflage: ["3L19"],
			cosmicpower: ["3L42"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hydropump: ["3L46"],
			icebeam: ["3M"],
			lightscreen: ["3M", "3L37"],
			minimize: ["3L33"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rapidspin: ["3L10"],
			recover: ["3L15"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			surf: ["3M"],
			swift: ["3L24"],
			tackle: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L6"],
			waterpulse: ["3M"],
		},
	},
	starmie: {
		inherit: true,
		learnset: {
			blizzard: ["3M"],
			confuseray: ["3L33"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rapidspin: ["3L1"],
			recover: ["3L1"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			skillswap: ["3M"],
			surf: ["3M"],
			swift: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	pinsir: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bind: ["3L7"],
			brickbreak: ["3M", "3L31"],
			bulkup: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			falseswipe: ["3E"],
			feintattack: ["3E"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyattack: ["3E"],
			guillotine: ["3L37"],
			harden: ["3L19"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3L25"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			seismictoss: ["3L13"],
			strength: ["3M"],
			submission: ["3L43"],
			sunnyday: ["3M"],
			swordsdance: ["3L49"],
			thief: ["3M"],
			toxic: ["3M"],
			visegrip: ["3L1"],
		},
	},
	magikarp: {
		inherit: true,
		learnset: {
			flail: ["3L30"],
			splash: ["3L1"],
			tackle: ["3L15"],
		},
	},
	gyarados: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L20"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			dragondance: ["3L50"],
			dragonrage: ["3L25"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L40"],
			hyperbeam: ["3M", "3L55"],
			icebeam: ["3M"],
			leer: ["3L30"],
			protect: ["3M"],
			raindance: ["3M", "3L45"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			surf: ["3M"],
			taunt: ["3M"],
			thrash: ["3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			twister: ["3L35"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	chinchou: {
		inherit: true,
		learnset: {
			amnesia: ["3E"],
			attract: ["3M"],
			blizzard: ["3M"],
			bubble: ["3L1"],
			charge: ["3L49"],
			confuseray: ["3L29"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L13", "3E"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L41"],
			icebeam: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			spark: ["3L25"],
			supersonic: ["3L5"],
			surf: ["3M"],
			takedown: ["3L37"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L17"],
			waterpulse: ["3M"],
		},
	},
	lanturn: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bubble: ["3L1"],
			charge: ["3L61"],
			confuseray: ["3L32"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L13"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L50"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			spark: ["3L25"],
			supersonic: ["3L1"],
			surf: ["3M"],
			takedown: ["3L43"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L17"],
			waterpulse: ["3M"],
		},
	},
	natu: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			calmmind: ["3M"],
			confuseray: ["3L40"],
			doubleteam: ["3M"],
			drillpeck: ["3E"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L30"],
			gigadrain: ["3M"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			leer: ["3L1"],
			lightscreen: ["3M"],
			nightshade: ["3L10"],
			peck: ["3L1"],
			protect: ["3M"],
			psychic: ["3M", "3L50"],
			quickattack: ["3E"],
			raindance: ["3M"],
			reflect: ["3M"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			solarbeam: ["3M"],
			steelwing: ["3M", "3E"],
			sunnyday: ["3M"],
			teleport: ["3L20"],
			thief: ["3M"],
			toxic: ["3M"],
			wish: ["3L30"],
		},
	},
	xatu: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			calmmind: ["3M"],
			confuseray: ["3L50"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L35"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leer: ["3L1"],
			lightscreen: ["3M"],
			nightshade: ["3L10"],
			peck: ["3L1"],
			protect: ["3M"],
			psychic: ["3M", "3L65"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			teleport: ["3L20"],
			thief: ["3M"],
			toxic: ["3M"],
			wish: ["3L35"],
		},
	},
	azurill: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			bubble: ["3L10"],
			charm: ["3L3"],
			doubleteam: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			sing: ["3E"],
			slam: ["3L15", "3E"],
			splash: ["3L1"],
			surf: ["3M"],
			tailwhip: ["3L6"],
			tickle: ["3E"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L21"],
			waterpulse: ["3M"],
		},
	},
	marill: {
		inherit: true,
		learnset: {
			amnesia: ["3E"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			bubblebeam: ["3L21"],
			defensecurl: ["3L3"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3L28"],
			doubleteam: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			futuresight: ["3E"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L45"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3E"],
			protect: ["3M"],
			raindance: ["3M", "3L36"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rollout: ["3L15"],
			secretpower: ["3M"],
			strength: ["3M"],
			substitute: ["3E"],
			supersonic: ["3E"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L6"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L10"],
			waterpulse: ["3M"],
		},
	},
	azumarill: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			bubblebeam: ["3L24"],
			defensecurl: ["3L1"],
			dig: ["3M"],
			dive: ["3M"],
			doubleedge: ["3L34"],
			doubleteam: ["3M"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L57"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			protect: ["3M"],
			raindance: ["3M", "3L45"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rollout: ["3L15"],
			secretpower: ["3M"],
			strength: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	wynaut: {
		inherit: true,
		learnset: {
			charm: ["3L1"],
			counter: ["3L15"],
			destinybond: ["3L15"],
			encore: ["3L1"],
			mirrorcoat: ["3L15"],
			safeguard: ["3L15"],
			splash: ["3L1"],
		},
	},
	wobbuffet: {
		inherit: true,
		learnset: {
			counter: ["3L1"],
			destinybond: ["3L1"],
			mirrorcoat: ["3L1"],
			safeguard: ["3L1"],
		},
	},
	girafarig: {
		inherit: true,
		learnset: {
			agility: ["3L31"],
			amnesia: ["3E"],
			astonish: ["3L7"],
			attract: ["3M"],
			batonpass: ["3L37"],
			calmmind: ["3M"],
			confusion: ["3L13"],
			crunch: ["3L49"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			foresight: ["3E"],
			frustration: ["3M"],
			futuresight: ["3E"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			magiccoat: ["3E"],
			odorsleuth: ["3L25"],
			protect: ["3M"],
			psybeam: ["3L43"],
			psychic: ["3M"],
			psychup: ["3E"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			stomp: ["3L19"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			takedown: ["3E"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			wish: ["3E"],
		},
	},
	heracross: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			brickbreak: ["3M", "3L23"],
			bulkup: ["3M"],
			counter: ["3L30"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endure: ["3L11"],
			facade: ["3M"],
			falseswipe: ["3E"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L17"],
			harden: ["3E"],
			hiddenpower: ["3M"],
			hornattack: ["3L6"],
			hyperbeam: ["3M"],
			leer: ["3L1"],
			megahorn: ["3L53"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3L45"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L37"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	slugma: {
		inherit: true,
		learnset: {
			acidarmor: ["3E"],
			amnesia: ["3L29"],
			attract: ["3M"],
			bodyslam: ["3L50"],
			doubleteam: ["3M"],
			ember: ["3L8"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M", "3L36"],
			frustration: ["3M"],
			harden: ["3L22"],
			hiddenpower: ["3M"],
			lightscreen: ["3M"],
			overheat: ["3M"],
			protect: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3L43"],
			rocksmash: ["3M"],
			rockthrow: ["3L15"],
			secretpower: ["3M"],
			smog: ["3L1"],
			sunnyday: ["3M"],
			toxic: ["3M"],
			yawn: ["3L1"],
		},
	},
	magcargo: {
		inherit: true,
		learnset: {
			amnesia: ["3L29"],
			attract: ["3M"],
			bodyslam: ["3L60"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M", "3L36"],
			frustration: ["3M"],
			harden: ["3L22"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M"],
			overheat: ["3M"],
			protect: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3L48"],
			rocksmash: ["3M"],
			rockthrow: ["3L1"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			smog: ["3L1"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
			yawn: ["3L1"],
		},
	},
	corsola: {
		inherit: true,
		learnset: {
			amnesia: ["3E"],
			ancientpower: ["3L45"],
			attract: ["3M"],
			barrier: ["3E"],
			blizzard: ["3M"],
			bubble: ["3L12"],
			bubblebeam: ["3L23"],
			calmmind: ["3M"],
			confuseray: ["3E"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			harden: ["3L6"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			ingrain: ["3E"],
			lightscreen: ["3M"],
			mirrorcoat: ["3L39"],
			mist: ["3E"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			recover: ["3L17"],
			reflect: ["3M"],
			refresh: ["3L17"],
			rest: ["3M"],
			return: ["3M"],
			rockblast: ["3L34"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			sandstorm: ["3M"],
			screech: ["3E"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			spikecannon: ["3L28"],
			strength: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	skarmory: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			agility: ["3L16"],
			aircutter: ["3L29"],
			attract: ["3M"],
			cut: ["3M"],
			doubleteam: ["3M"],
			drillpeck: ["3E"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L26"],
			hiddenpower: ["3M"],
			leer: ["3L1"],
			metalsound: ["3L45"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			sandattack: ["3L10"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			skyattack: ["3E"],
			spikes: ["3L42"],
			steelwing: ["3M", "3L32"],
			sunnyday: ["3M"],
			swift: ["3L13"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	phanpy: {
		inherit: true,
		learnset: {
			ancientpower: ["3E"],
			attract: ["3M"],
			bodyslam: ["3E"],
			counter: ["3E"],
			defensecurl: ["3L9"],
			doubleedge: ["3L49"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endure: ["3L41"],
			facade: ["3M"],
			fissure: ["3E"],
			flail: ["3L17"],
			focusenergy: ["3E"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			odorsleuth: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollout: ["3L33"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			snore: ["3E"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L25"],
			toxic: ["3M"],
		},
	},
	donphan: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			defensecurl: ["3L9"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L49"],
			facade: ["3M"],
			flail: ["3L17"],
			frustration: ["3M"],
			furyattack: ["3L25"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hornattack: ["3L1"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			odorsleuth: ["3L1"],
			protect: ["3M"],
			rapidspin: ["3L41"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollout: ["3L33"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	treecko: {
		inherit: true,
		learnset: {
			absorb: ["3L6"],
			aerialace: ["3M"],
			agility: ["3L31"],
			attract: ["3M"],
			brickbreak: ["3M"],
			bulletseed: ["3M"],
			crunch: ["3E"],
			crushclaw: ["3E"],
			cut: ["3M"],
			detect: ["3L41"],
			dig: ["3M"],
			doubleteam: ["3M"],
			dragonbreath: ["3E"],
			endeavor: ["3E"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M", "3L46"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			leechseed: ["3E"],
			leer: ["3L1"],
			megadrain: ["3L26"],
			mudsport: ["3E"],
			pound: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L16"],
			quickattack: ["3L11"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			screech: ["3L21"],
			secretpower: ["3M"],
			slam: ["3L36"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	grovyle: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			aerialace: ["3M"],
			agility: ["3L35"],
			attract: ["3M"],
			brickbreak: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			detect: ["3L47"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			falseswipe: ["3L53"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furycutter: ["3L16"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			leafblade: ["3L29"],
			leer: ["3L1"],
			pound: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L17"],
			quickattack: ["3L1"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			screech: ["3L23"],
			secretpower: ["3M"],
			slam: ["3L41"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	sceptile: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			aerialace: ["3M"],
			agility: ["3L35"],
			attract: ["3M"],
			brickbreak: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			detect: ["3L51"],
			dig: ["3M"],
			doubleteam: ["3M"],
			dragonclaw: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			falseswipe: ["3L59"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furycutter: ["3L16"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leafblade: ["3L29"],
			leer: ["3L1"],
			pound: ["3L1"],
			protect: ["3M"],
			pursuit: ["3L17"],
			quickattack: ["3L1"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			screech: ["3L23"],
			secretpower: ["3M"],
			slam: ["3L43"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	torchic: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			counter: ["3E"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			ember: ["3L10"],
			endure: ["3E"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L25"],
			flamethrower: ["3M", "3L43"],
			focusenergy: ["3L7"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			mirrormove: ["3L37"],
			overheat: ["3M"],
			peck: ["3L16"],
			protect: ["3M"],
			quickattack: ["3L28"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3E"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L19"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			slash: ["3L34"],
			smellingsalts: ["3E"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swagger: ["3E"],
			toxic: ["3M"],
		},
	},
	combusken: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			brickbreak: ["3M"],
			bulkup: ["3M", "3L28"],
			cut: ["3M"],
			dig: ["3M"],
			doublekick: ["3L16"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			mirrormove: ["3L43"],
			overheat: ["3M"],
			peck: ["3L17"],
			protect: ["3M"],
			quickattack: ["3L32"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L21"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			skyuppercut: ["3L50"],
			slash: ["3L39"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	blaziken: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blazekick: ["3L36"],
			brickbreak: ["3M"],
			bulkup: ["3M", "3L28"],
			cut: ["3M"],
			dig: ["3M"],
			doublekick: ["3L16"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			ember: ["3L1"],
			facade: ["3M"],
			fireblast: ["3M"],
			firepunch: ["3L1"],
			flamethrower: ["3M"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			mirrormove: ["3L49"],
			overheat: ["3M"],
			peck: ["3L17"],
			protect: ["3M"],
			quickattack: ["3L32"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L21"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			skyuppercut: ["3L59"],
			slash: ["3L42"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	mudkip: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bide: ["3L15"],
			blizzard: ["3M"],
			curse: ["3E"],
			dig: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			endeavor: ["3L46"],
			facade: ["3M"],
			foresight: ["3L19"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L42"],
			iceball: ["3E"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mirrorcoat: ["3E"],
			mudslap: ["3L6"],
			mudsport: ["3L24"],
			protect: ["3M", "3L37"],
			raindance: ["3M"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			stomp: ["3E"],
			strength: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L28"],
			toxic: ["3M"],
			uproar: ["3E"],
			waterfall: ["3M"],
			watergun: ["3L10"],
			waterpulse: ["3M"],
			whirlpool: ["3L33"],
		},
	},
	marshtomp: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bide: ["3L15"],
			blizzard: ["3M"],
			dig: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L46"],
			endeavor: ["3L53"],
			facade: ["3M"],
			foresight: ["3L20"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			muddywater: ["3L37"],
			mudshot: ["3L16"],
			mudslap: ["3L1"],
			mudsport: ["3L25"],
			protect: ["3M", "3L42"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L31"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	swampert: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bide: ["3L15"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			dig: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L52"],
			endeavor: ["3L61"],
			facade: ["3M"],
			focuspunch: ["3M"],
			foresight: ["3L20"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			muddywater: ["3L39"],
			mudshot: ["3L16"],
			mudslap: ["3L1"],
			mudsport: ["3L25"],
			protect: ["3M", "3L46"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L31"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	poochyena: {
		inherit: true,
		learnset: {
			astonish: ["3E"],
			attract: ["3M"],
			bite: ["3L13"],
			covet: ["3E"],
			crunch: ["3L41"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			howl: ["3L5"],
			irontail: ["3M"],
			leer: ["3E"],
			odorsleuth: ["3L17"],
			poisonfang: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L21"],
			rocksmash: ["3M"],
			sandattack: ["3L9"],
			scaryface: ["3L29"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			swagger: ["3L25"],
			tackle: ["3L1"],
			takedown: ["3L33"],
			taunt: ["3M", "3L37"],
			thief: ["3M", "3L45"],
			torment: ["3M"],
			toxic: ["3M"],
			yawn: ["3E"],
		},
	},
	mightyena: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L1"],
			crunch: ["3L47"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			howl: ["3L1"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			odorsleuth: ["3L17"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L22"],
			rocksmash: ["3M"],
			sandattack: ["3L1"],
			scaryface: ["3L32"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			snatch: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swagger: ["3L27"],
			tackle: ["3L1"],
			takedown: ["3L37"],
			taunt: ["3M", "3L42"],
			thief: ["3M", "3L52"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	zigzagoon: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bellydrum: ["3L41"],
			blizzard: ["3M"],
			charm: ["3E"],
			covet: ["3L29"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L33"],
			frustration: ["3M"],
			growl: ["3L1"],
			headbutt: ["3L9"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mudsport: ["3L21"],
			odorsleuth: ["3L17"],
			pinmissile: ["3L25"],
			protect: ["3M"],
			pursuit: ["3E"],
			raindance: ["3M"],
			rest: ["3M", "3L37"],
			return: ["3M"],
			rocksmash: ["3M"],
			sandattack: ["3L13"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			substitute: ["3E"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L5"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			tickle: ["3E"],
			toxic: ["3M"],
			trick: ["3E"],
			waterpulse: ["3M"],
		},
	},
	linoone: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bellydrum: ["3L53"],
			blizzard: ["3M"],
			covet: ["3L35"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L29"],
			growl: ["3L1"],
			headbutt: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mudsport: ["3L23"],
			odorsleuth: ["3L17"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L47"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			sandattack: ["3L13"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slash: ["3L41"],
			strength: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L1"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	wurmple: {
		inherit: true,
		learnset: {
			poisonsting: ["3L5"],
			stringshot: ["3L1"],
			tackle: ["3L1"],
		},
	},
	silcoon: {
		inherit: true,
		learnset: {
			harden: ["3L1"],
		},
	},
	beautifly: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			aerialace: ["3M"],
			attract: ["3M", "3L31"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M", "3L38"],
			gust: ["3L13"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			megadrain: ["3L24"],
			morningsun: ["3L20"],
			protect: ["3M"],
			psychic: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			silverwind: ["3L34"],
			solarbeam: ["3M"],
			stunspore: ["3L17"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			whirlwind: ["3L27"],
		},
	},
	cascoon: {
		inherit: true,
		learnset: {
			harden: ["3L1"],
		},
	},
	dustox: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			confusion: ["3L1"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			gust: ["3L13"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M", "3L31"],
			moonlight: ["3L20"],
			protect: ["3M", "3L17"],
			psybeam: ["3L24"],
			psychic: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			silverwind: ["3L34"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M", "3L38"],
			whirlwind: ["3L27"],
		},
	},
	lotad: {
		inherit: true,
		learnset: {
			absorb: ["3L7"],
			astonish: ["3L1"],
			attract: ["3M"],
			blizzard: ["3M"],
			bulletseed: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3E"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growl: ["3L3"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			leechseed: ["3E"],
			megadrain: ["3L43"],
			mist: ["3L21"],
			naturepower: ["3L13"],
			protect: ["3M"],
			raindance: ["3M", "3L31"],
			razorleaf: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			sweetscent: ["3E"],
			synthesis: ["3E"],
			thief: ["3M"],
			toxic: ["3M"],
			watergun: ["3E"],
			waterpulse: ["3M"],
		},
	},
	lombre: {
		inherit: true,
		learnset: {
			absorb: ["3L7"],
			astonish: ["3L1"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			bulletseed: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fakeout: ["3L19"],
			flash: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L25"],
			gigadrain: ["3M"],
			growl: ["3L3"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L49"],
			icebeam: ["3M"],
			naturepower: ["3L13"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thief: ["3M", "3L37"],
			toxic: ["3M"],
			uproar: ["3L43"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			watersport: ["3L31"],
		},
	},
	ludicolo: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			astonish: ["3L1"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			bulletseed: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			naturepower: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	seedot: {
		inherit: true,
		learnset: {
			amnesia: ["3E"],
			attract: ["3M"],
			bide: ["3L1"],
			bulletseed: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			explosion: ["3L43"],
			facade: ["3M"],
			falseswipe: ["3E"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growth: ["3L7"],
			harden: ["3L3"],
			hiddenpower: ["3M"],
			leechseed: ["3E"],
			naturepower: ["3L13"],
			protect: ["3M"],
			quickattack: ["3E"],
			razorwind: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			solarbeam: ["3M"],
			sunnyday: ["3M", "3L31"],
			synthesis: ["3L21"],
			takedown: ["3E"],
			toxic: ["3M"],
		},
	},
	nuzleaf: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			brickbreak: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			extrasensory: ["3L49"],
			facade: ["3M"],
			fakeout: ["3L19"],
			feintattack: ["3L31"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growth: ["3L7"],
			harden: ["3L3"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			naturepower: ["3L13"],
			pound: ["3L1"],
			protect: ["3M"],
			razorwind: ["3L37"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swagger: ["3L43"],
			thief: ["3M"],
			torment: ["3M", "3L25"],
			toxic: ["3M"],
		},
	},
	shiftry: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			brickbreak: ["3M"],
			bulletseed: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growth: ["3L1"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			naturepower: ["3L1"],
			pound: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	taillow: {
		inherit: true,
		learnset: {
			aerialace: ["3M", "3L34"],
			agility: ["3L43"],
			attract: ["3M"],
			doubleteam: ["3M", "3L19"],
			endeavor: ["3L26"],
			facade: ["3M"],
			fly: ["3M"],
			focusenergy: ["3L4"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			mirrormove: ["3E"],
			peck: ["3L1"],
			protect: ["3M"],
			pursuit: ["3E"],
			quickattack: ["3L8"],
			rage: ["3E"],
			raindance: ["3M"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			skyattack: ["3E"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			supersonic: ["3E"],
			thief: ["3M"],
			toxic: ["3M"],
			wingattack: ["3L13"],
		},
	},
	swellow: {
		inherit: true,
		learnset: {
			aerialace: ["3M", "3L38"],
			agility: ["3L49"],
			attract: ["3M"],
			doubleteam: ["3M", "3L19"],
			endeavor: ["3L28"],
			facade: ["3M"],
			fly: ["3M"],
			focusenergy: ["3L1"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			peck: ["3L1"],
			protect: ["3M"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			wingattack: ["3L13"],
		},
	},
	wingull: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			agility: ["3L55", "3E"],
			attract: ["3M"],
			blizzard: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			gust: ["3E"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			mist: ["3L21", "3E"],
			protect: ["3M"],
			pursuit: ["3L43"],
			quickattack: ["3L31"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			steelwing: ["3M"],
			supersonic: ["3L7"],
			thief: ["3M"],
			toxic: ["3M"],
			twister: ["3E"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
			watersport: ["3E"],
			wingattack: ["3L13"],
		},
	},
	pelipper: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L61"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			mist: ["3L21"],
			protect: ["3M", "3L25"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			spitup: ["3L47"],
			steelwing: ["3M"],
			stockpile: ["3L33"],
			supersonic: ["3L7"],
			surf: ["3M"],
			swallow: ["3L33"],
			thief: ["3M"],
			toxic: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
			wingattack: ["3L1"],
		},
	},
	ralts: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			calmmind: ["3M", "3L21"],
			charm: ["3S0"],
			confusion: ["3L6"],
			destinybond: ["3E"],
			disable: ["3E"],
			doubleteam: ["3M", "3L11"],
			dreameater: ["3L46"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L36"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hypnosis: ["3L41"],
			imprison: ["3L31"],
			lightscreen: ["3M"],
			meanlook: ["3E"],
			memento: ["3E"],
			protect: ["3M"],
			psychic: ["3M", "3L26"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L16"],
			thief: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			willowisp: ["3E"],
			wish: ["3S1"],
		},
	},
	kirlia: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			calmmind: ["3M", "3L21"],
			confusion: ["3L1"],
			doubleteam: ["3M", "3L1"],
			dreameater: ["3L54"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L40"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hypnosis: ["3L47"],
			imprison: ["3L33"],
			lightscreen: ["3M"],
			protect: ["3M"],
			psychic: ["3M", "3L26"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L1"],
			thief: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	gardevoir: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			calmmind: ["3M", "3L21"],
			confusion: ["3L1"],
			doubleteam: ["3M", "3L1"],
			dreameater: ["3L60"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L42"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			hypnosis: ["3L51"],
			imprison: ["3L33"],
			lightscreen: ["3M"],
			protect: ["3M"],
			psychic: ["3M", "3L26"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			teleport: ["3L1"],
			thief: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	surskit: {
		inherit: true,
		learnset: {
			agility: ["3L31"],
			attract: ["3M"],
			blizzard: ["3M"],
			bubble: ["3L1"],
			bubblebeam: ["3L25"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			foresight: ["3E"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			haze: ["3L37"],
			hiddenpower: ["3M"],
			hydropump: ["3E"],
			icebeam: ["3M"],
			mindreader: ["3E"],
			mist: ["3L37"],
			mudshot: ["3E"],
			protect: ["3M"],
			psybeam: ["3E"],
			quickattack: ["3L7"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			solarbeam: ["3M"],
			sunnyday: ["3M"],
			sweetscent: ["3L13"],
			thief: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			watersport: ["3L19"],
		},
	},
	masquerain: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			bubble: ["3L1"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			gust: ["3L26"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			protect: ["3M"],
			quickattack: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			scaryface: ["3L33"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			silverwind: ["3L47"],
			solarbeam: ["3M"],
			stunspore: ["3L40"],
			sunnyday: ["3M"],
			sweetscent: ["3L1"],
			thief: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
			whirlwind: ["3L53"],
		},
	},
	shroomish: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			attract: ["3M"],
			bulletseed: ["3M"],
			charm: ["3E"],
			doubleteam: ["3M"],
			facade: ["3M"],
			faketears: ["3E"],
			falseswipe: ["3E"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M", "3L45"],
			growth: ["3L36"],
			headbutt: ["3L22"],
			helpinghand: ["3E"],
			hiddenpower: ["3M"],
			leechseed: ["3L10"],
			megadrain: ["3L16"],
			poisonpowder: ["3L28"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			spore: ["3L54"],
			stunspore: ["3L7"],
			sunnyday: ["3M"],
			swagger: ["3E"],
			tackle: ["3L4"],
			toxic: ["3M"],
		},
	},
	breloom: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			attract: ["3M"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			bulletseed: ["3M"],
			counter: ["3L28"],
			cut: ["3M"],
			doubleteam: ["3M"],
			dynamicpunch: ["3L54"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			headbutt: ["3L22"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leechseed: ["3L1"],
			machpunch: ["3L23"],
			megadrain: ["3L16"],
			mindreader: ["3L45"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			skyuppercut: ["3L36"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			stunspore: ["3L1"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
		},
	},
	slakoth: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			amnesia: ["3L25"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3E"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3L37"],
			covet: ["3L31"],
			crushclaw: ["3E"],
			curse: ["3E"],
			cut: ["3M"],
			doubleteam: ["3M"],
			encore: ["3L7"],
			facade: ["3M"],
			feintattack: ["3L19"],
			fireblast: ["3M"],
			flail: ["3L43"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			protect: ["3M"],
			pursuit: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slackoff: ["3L13"],
			slash: ["3E"],
			sleeptalk: ["3E"],
			snore: ["3E"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			yawn: ["3L1"],
		},
	},
	vigoroth: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3L37"],
			cut: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			encore: ["3L1"],
			endure: ["3L25"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L1"],
			focuspunch: ["3M", "3L43"],
			frustration: ["3M"],
			furyswipes: ["3L19"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3L49"],
			roar: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slash: ["3L31"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			uproar: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	slaking: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			amnesia: ["3L25"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3L37"],
			covet: ["3L31"],
			cut: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			encore: ["3L1"],
			facade: ["3M"],
			feintattack: ["3L19"],
			fireblast: ["3M"],
			flail: ["3L43"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slackoff: ["3L1"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swagger: ["3L36"],
			taunt: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			yawn: ["3L1"],
		},
	},
	nincada: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			cut: ["3M"],
			dig: ["3M", "3L45"],
			doubleteam: ["3M"],
			endure: ["3E"],
			facade: ["3M"],
			falseswipe: ["3L25"],
			feintattack: ["3E"],
			flash: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L14"],
			gigadrain: ["3M"],
			gust: ["3E"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			leechlife: ["3L5"],
			metalclaw: ["3L38"],
			mindreader: ["3L19"],
			mudslap: ["3L31"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L9"],
			sandstorm: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			silverwind: ["3E"],
			solarbeam: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	ninjask: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			agility: ["3L38"],
			attract: ["3M"],
			batonpass: ["3L45"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M", "3L20"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			furycutter: ["3L20"],
			furyswipes: ["3L14"],
			gigadrain: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechlife: ["3L1"],
			mindreader: ["3L19"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L1"],
			sandstorm: ["3M"],
			scratch: ["3L1"],
			screech: ["3L20"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			slash: ["3L31"],
			solarbeam: ["3M"],
			sunnyday: ["3M"],
			swordsdance: ["3L25"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	shedinja: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			agility: ["3R"],
			batonpass: ["3R"],
			confuseray: ["3L31"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L14"],
			gigadrain: ["3M"],
			grudge: ["3L45"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechlife: ["3L5"],
			mindreader: ["3L19"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L9"],
			sandstorm: ["3M"],
			scratch: ["3L1"],
			screech: ["3R"],
			secretpower: ["3M"],
			shadowball: ["3M", "3L38"],
			slash: ["3R"],
			solarbeam: ["3M"],
			spite: ["3L25"],
			sunnyday: ["3M"],
			swordsdance: ["3R"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	whismur: {
		inherit: true,
		learnset: {
			astonish: ["3L11"],
			attract: ["3M"],
			blizzard: ["3M"],
			doubleteam: ["3M"],
			extrasensory: ["3E"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			howl: ["3L15"],
			hypervoice: ["3L45"],
			icebeam: ["3M"],
			pound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L41"],
			return: ["3M"],
			roar: ["3M", "3L35"],
			screech: ["3L31"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sleeptalk: ["3L41"],
			smellingsalts: ["3E"],
			snore: ["3E"],
			solarbeam: ["3M"],
			stomp: ["3L25"],
			sunnyday: ["3M"],
			supersonic: ["3L21"],
			swagger: ["3E"],
			takedown: ["3E"],
			toxic: ["3M"],
			uproar: ["3L5"],
			waterpulse: ["3M"],
		},
	},
	loudred: {
		inherit: true,
		learnset: {
			astonish: ["3L1"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			howl: ["3L1"],
			hypervoice: ["3L57"],
			icebeam: ["3M"],
			overheat: ["3M"],
			pound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L51"],
			return: ["3M"],
			roar: ["3M", "3L43"],
			rocksmash: ["3M"],
			screech: ["3L37"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sleeptalk: ["3L51"],
			solarbeam: ["3M"],
			stomp: ["3L29"],
			strength: ["3M"],
			sunnyday: ["3M"],
			supersonic: ["3L23"],
			taunt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			uproar: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	exploud: {
		inherit: true,
		learnset: {
			astonish: ["3L1"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			howl: ["3L1"],
			hyperbeam: ["3M", "3L40"],
			hypervoice: ["3L63"],
			icebeam: ["3M"],
			overheat: ["3M"],
			pound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L55"],
			return: ["3M"],
			roar: ["3M", "3L45"],
			rocksmash: ["3M"],
			screech: ["3L37"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sleeptalk: ["3L55"],
			solarbeam: ["3M"],
			stomp: ["3L29"],
			strength: ["3M"],
			sunnyday: ["3M"],
			supersonic: ["3L23"],
			taunt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			uproar: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	makuhita: {
		inherit: true,
		learnset: {
			armthrust: ["3L10"],
			attract: ["3M"],
			bellydrum: ["3L37"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			counter: ["3E"],
			crosschop: ["3E"],
			detect: ["3E"],
			dig: ["3M"],
			doubleteam: ["3M"],
			dynamicpunch: ["3E"],
			earthquake: ["3M"],
			endure: ["3L40"],
			facade: ["3M"],
			fakeout: ["3L19"],
			feintattack: ["3E"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			foresight: ["3E"],
			frustration: ["3M"],
			helpinghand: ["3E"],
			hiddenpower: ["3M"],
			knockoff: ["3L28"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			revenge: ["3E"],
			reversal: ["3L49"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L4"],
			secretpower: ["3M"],
			seismictoss: ["3L46"],
			smellingsalts: ["3L31"],
			strength: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
			vitalthrow: ["3L13"],
			whirlwind: ["3L22"],
		},
	},
	hariyama: {
		inherit: true,
		learnset: {
			armthrust: ["3L1"],
			attract: ["3M"],
			bellydrum: ["3L40"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endure: ["3L44"],
			facade: ["3M"],
			fakeout: ["3L19"],
			focusenergy: ["3L1"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			knockoff: ["3L29"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3L55"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L1"],
			secretpower: ["3M"],
			seismictoss: ["3L51"],
			smellingsalts: ["3L33"],
			strength: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
			vitalthrow: ["3L13"],
			whirlwind: ["3L22"],
		},
	},
	nosepass: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			block: ["3L16"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			explosion: ["3E"],
			facade: ["3M"],
			frustration: ["3M"],
			harden: ["3L7"],
			hiddenpower: ["3M"],
			lockon: ["3L46"],
			magnitude: ["3E"],
			protect: ["3M"],
			rest: ["3M", "3L37"],
			return: ["3M"],
			rockslide: ["3L28"],
			rocksmash: ["3M"],
			rockthrow: ["3L13"],
			rocktomb: ["3M"],
			rollout: ["3E"],
			sandstorm: ["3M", "3L31"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			taunt: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			thunderwave: ["3L22"],
			torment: ["3M"],
			toxic: ["3M"],
			zapcannon: ["3L43"],
		},
	},
	skitty: {
		inherit: true,
		learnset: {
			assist: ["3L19"],
			attract: ["3M", "3L7"],
			batonpass: ["3E"],
			blizzard: ["3M"],
			calmmind: ["3M"],
			charm: ["3L25"],
			covet: ["3L31"],
			dig: ["3M"],
			doubleedge: ["3L39"],
			doubleslap: ["3L15"],
			doubleteam: ["3M"],
			facade: ["3M"],
			faketears: ["3E"],
			feintattack: ["3L27"],
			flash: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			healbell: ["3L37"],
			helpinghand: ["3E"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			protect: ["3M"],
			psychup: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L13"],
			solarbeam: ["3M"],
			substitute: ["3E"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			tailwhip: ["3L3"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			tickle: ["3E"],
			toxic: ["3M"],
			uproar: ["3E"],
			waterpulse: ["3M"],
			wish: ["3E"],
		},
	},
	delcatty: {
		inherit: true,
		learnset: {
			attract: ["3M", "3L1"],
			blizzard: ["3M"],
			calmmind: ["3M"],
			dig: ["3M"],
			doubleslap: ["3L1"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sing: ["3L1"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	sableye: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			astonish: ["3L13"],
			attract: ["3M"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			confuseray: ["3L37"],
			cut: ["3M"],
			detect: ["3L25"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fakeout: ["3L21"],
			feintattack: ["3L29"],
			flash: ["3M"],
			focuspunch: ["3M"],
			foresight: ["3L5"],
			frustration: ["3M"],
			furyswipes: ["3L17"],
			hiddenpower: ["3M"],
			knockoff: ["3L33"],
			leer: ["3L1"],
			meanlook: ["3L45"],
			moonlight: ["3E"],
			nightshade: ["3L9"],
			protect: ["3M"],
			psychic: ["3M"],
			psychup: ["3E"],
			raindance: ["3M"],
			recover: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M", "3L41"],
			shockwave: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	mawile: {
		inherit: true,
		learnset: {
			ancientpower: ["3E"],
			astonish: ["3L1"],
			attract: ["3M"],
			batonpass: ["3L31"],
			bite: ["3L11"],
			brickbreak: ["3M"],
			crunch: ["3L36"],
			doubleteam: ["3M"],
			facade: ["3M"],
			faketears: ["3L6"],
			falseswipe: ["3E"],
			feintattack: ["3L26"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irondefense: ["3L41"],
			poisonfang: ["3E"],
			protect: ["3M"],
			psychup: ["3E"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			spitup: ["3L46"],
			stockpile: ["3L46"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swallow: ["3L46"],
			sweetscent: ["3L16"],
			swordsdance: ["3E"],
			taunt: ["3M"],
			tickle: ["3E"],
			torment: ["3M"],
			toxic: ["3M"],
			visegrip: ["3L21"],
		},
	},
	aron: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bodyslam: ["3E"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3L44"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			endeavor: ["3E"],
			facade: ["3M"],
			frustration: ["3M"],
			harden: ["3L4"],
			headbutt: ["3L10"],
			hiddenpower: ["3M"],
			irondefense: ["3L17"],
			irontail: ["3M", "3L29"],
			metalclaw: ["3L13"],
			metalsound: ["3L39"],
			mudslap: ["3L7"],
			protect: ["3M", "3L34"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L21"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			smellingsalts: ["3E"],
			stomp: ["3E"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L25"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	lairon: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3L53"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			harden: ["3L1"],
			headbutt: ["3L1"],
			hiddenpower: ["3M"],
			irondefense: ["3L17"],
			irontail: ["3M", "3L29"],
			metalclaw: ["3L13"],
			metalsound: ["3L45"],
			mudslap: ["3L1"],
			protect: ["3M", "3L37"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L21"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L25"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	aggron: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			doubleedge: ["3L63"],
			doubleteam: ["3M"],
			dragonclaw: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			harden: ["3L1"],
			headbutt: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irondefense: ["3L17"],
			irontail: ["3M", "3L29"],
			metalclaw: ["3L13"],
			metalsound: ["3L50"],
			mudslap: ["3L1"],
			protect: ["3M", "3L37"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L21"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L25"],
			taunt: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	meditite: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			batonpass: ["3E"],
			bide: ["3L1"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			calmmind: ["3M", "3L28"],
			confusion: ["3L9"],
			detect: ["3L12"],
			doubleteam: ["3M"],
			dynamicpunch: ["3E"],
			facade: ["3M"],
			fakeout: ["3E"],
			firepunch: ["3E"],
			flash: ["3M"],
			focuspunch: ["3M"],
			foresight: ["3E"],
			frustration: ["3M"],
			hiddenpower: ["3M", "3L17"],
			highjumpkick: ["3L32"],
			icepunch: ["3E"],
			lightscreen: ["3M"],
			meditate: ["3L4"],
			mindreader: ["3L22"],
			protect: ["3M"],
			psychic: ["3M"],
			psychup: ["3L36"],
			raindance: ["3M"],
			recover: ["3L44"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3L41"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			thunderpunch: ["3E"],
			toxic: ["3M"],
		},
	},
	medicham: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bide: ["3L1"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			calmmind: ["3M", "3L28"],
			confusion: ["3L1"],
			detect: ["3L1"],
			doubleteam: ["3M"],
			facade: ["3M"],
			firepunch: ["3L1"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M", "3L17"],
			highjumpkick: ["3L32"],
			hyperbeam: ["3M"],
			icepunch: ["3L1"],
			lightscreen: ["3M"],
			meditate: ["3L1"],
			mindreader: ["3L22"],
			protect: ["3M"],
			psychic: ["3M"],
			psychup: ["3L36"],
			raindance: ["3M"],
			recover: ["3L54"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			reversal: ["3L46"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			thunderpunch: ["3L1"],
			toxic: ["3M"],
		},
	},
	electrike: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L33"],
			charge: ["3L41"],
			crunch: ["3E"],
			curse: ["3E"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			headbutt: ["3E"],
			hiddenpower: ["3M"],
			howl: ["3L12"],
			irontail: ["3M"],
			leer: ["3L9"],
			odorsleuth: ["3L25"],
			protect: ["3M"],
			quickattack: ["3L17"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L28"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			spark: ["3L20"],
			strength: ["3M"],
			swift: ["3E"],
			tackle: ["3L1"],
			thief: ["3M"],
			thunder: ["3M", "3L36"],
			thunderbolt: ["3M"],
			thunderwave: ["3L4"],
			toxic: ["3M"],
			uproar: ["3E"],
		},
	},
	manectric: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L39"],
			charge: ["3L53"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			howl: ["3L1"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			odorsleuth: ["3L25"],
			protect: ["3M"],
			quickattack: ["3L17"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3L31"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			spark: ["3L20"],
			strength: ["3M"],
			tackle: ["3L1"],
			thief: ["3M"],
			thunder: ["3M", "3L45"],
			thunderbolt: ["3M"],
			thunderwave: ["3L1"],
			toxic: ["3M"],
		},
	},
	plusle: {
		inherit: true,
		learnset: {
			agility: ["3L47"],
			attract: ["3M"],
			batonpass: ["3L40"],
			charge: ["3L31"],
			doubleteam: ["3M"],
			encore: ["3L22"],
			facade: ["3M"],
			faketears: ["3L28"],
			flash: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			helpinghand: ["3L13"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			protect: ["3M"],
			quickattack: ["3L10"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			spark: ["3L19"],
			substitute: ["3E"],
			thunder: ["3M", "3L37"],
			thunderbolt: ["3M"],
			thunderwave: ["3L4"],
			toxic: ["3M"],
			wish: ["3E"],
		},
	},
	minun: {
		inherit: true,
		learnset: {
			agility: ["3L47"],
			attract: ["3M"],
			batonpass: ["3L40"],
			charge: ["3L31"],
			charm: ["3L28"],
			doubleteam: ["3M"],
			encore: ["3L22"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			helpinghand: ["3L13"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			protect: ["3M"],
			quickattack: ["3L10"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			spark: ["3L19"],
			substitute: ["3E"],
			thunder: ["3M", "3L37"],
			thunderbolt: ["3M"],
			thunderwave: ["3L4"],
			toxic: ["3M"],
			wish: ["3E"],
		},
	},
	volbeat: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			batonpass: ["3E"],
			brickbreak: ["3M"],
			confuseray: ["3L5"],
			doubleedge: ["3L37"],
			doubleteam: ["3M", "3L9"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			helpinghand: ["3L33"],
			hiddenpower: ["3M"],
			lightscreen: ["3M"],
			moonlight: ["3L13"],
			protect: ["3M", "3L29"],
			quickattack: ["3L17"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			signalbeam: ["3L25"],
			silverwind: ["3E"],
			solarbeam: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			tailglow: ["3L21"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			trick: ["3E"],
			waterpulse: ["3M"],
		},
	},
	illumise: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			batonpass: ["3E"],
			brickbreak: ["3M"],
			charm: ["3L9"],
			covet: ["3L37"],
			doubleteam: ["3M"],
			encore: ["3L25"],
			facade: ["3M"],
			flash: ["3M"],
			flatter: ["3L29"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growth: ["3E"],
			helpinghand: ["3L33"],
			hiddenpower: ["3M"],
			lightscreen: ["3M"],
			moonlight: ["3L13"],
			protect: ["3M"],
			quickattack: ["3L17"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			silverwind: ["3E"],
			solarbeam: ["3M"],
			sunnyday: ["3M"],
			sweetscent: ["3L5"],
			tackle: ["3L1"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wish: ["3L21"],
		},
	},
	roselia: {
		learnset: {
			absorb: ["3L1"],
			aromatherapy: ["3L53"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cottonspore: ["3E"],
			cut: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M", "3L33"],
			grasswhistle: ["3L29"],
			growth: ["3L5"],
			hiddenpower: ["3M"],
			ingrain: ["3L41"],
			leechseed: ["3L21"],
			magicalleaf: ["3L25"],
			megadrain: ["3L17"],
			petaldance: ["3L49"],
			pinmissile: ["3E"],
			poisonsting: ["3L9"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			spikes: ["3E"],
			stunspore: ["3L13"],
			sunnyday: ["3M"],
			sweetscent: ["3L37"],
			synthesis: ["3L57", "3E"],
			toxic: ["3M", "3L45"],
		},
	},
	gulpin: {
		inherit: true,
		learnset: {
			acidarmor: ["3E"],
			amnesia: ["3L17"],
			attract: ["3M"],
			bulletseed: ["3M"],
			doubleteam: ["3M"],
			dreameater: ["3E"],
			encore: ["3L23"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			poisongas: ["3L9"],
			pound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sludge: ["3L14"],
			sludgebomb: ["3M", "3L39"],
			smog: ["3E"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			spitup: ["3L34"],
			stockpile: ["3L34"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swallow: ["3L34"],
			toxic: ["3M", "3L28"],
			waterpulse: ["3M"],
			yawn: ["3L6"],
		},
	},
	swalot: {
		inherit: true,
		learnset: {
			amnesia: ["3L17"],
			attract: ["3M"],
			bodyslam: ["3L26"],
			bulletseed: ["3M"],
			doubleteam: ["3M"],
			encore: ["3L23"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			poisongas: ["3L1"],
			pound: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			sludge: ["3L1"],
			sludgebomb: ["3M", "3L48"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			spitup: ["3L40"],
			stockpile: ["3L40"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swallow: ["3L40"],
			toxic: ["3M", "3L31"],
			waterpulse: ["3M"],
			yawn: ["3L1"],
		},
	},
	carvanha: {
		inherit: true,
		learnset: {
			agility: ["3L43"],
			attract: ["3M"],
			bite: ["3L1"],
			blizzard: ["3M"],
			crunch: ["3L22"],
			dive: ["3M"],
			doubleedge: ["3E"],
			doubleteam: ["3M"],
			facade: ["3M"],
			focusenergy: ["3L13"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3E"],
			icebeam: ["3M"],
			leer: ["3L1"],
			protect: ["3M"],
			rage: ["3L7"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			scaryface: ["3L16"],
			screech: ["3L28"],
			secretpower: ["3M"],
			surf: ["3M"],
			swagger: ["3L37"],
			takedown: ["3L31"],
			taunt: ["3M"],
			thief: ["3M"],
			thrash: ["3E"],
			torment: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	sharpedo: {
		inherit: true,
		learnset: {
			agility: ["3L53"],
			attract: ["3M"],
			bite: ["3L1"],
			blizzard: ["3M"],
			crunch: ["3L22"],
			dive: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			focusenergy: ["3L1"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			leer: ["3L1"],
			protect: ["3M"],
			rage: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L16"],
			screech: ["3L28"],
			secretpower: ["3M"],
			skullbash: ["3L48"],
			slash: ["3L33"],
			strength: ["3M"],
			surf: ["3M"],
			swagger: ["3L43"],
			taunt: ["3M", "3L38"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	wailmer: {
		inherit: true,
		learnset: {
			amnesia: ["3L46"],
			astonish: ["3L23"],
			attract: ["3M"],
			blizzard: ["3M"],
			curse: ["3E"],
			dive: ["3M"],
			doubleedge: ["3E"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			fissure: ["3E"],
			frustration: ["3M"],
			growl: ["3L5"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L50"],
			icebeam: ["3M"],
			mist: ["3L32"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L37"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollout: ["3L14"],
			secretpower: ["3M"],
			sleeptalk: ["3E"],
			snore: ["3E"],
			splash: ["3L1"],
			strength: ["3M"],
			surf: ["3M"],
			swagger: ["3E"],
			thrash: ["3E"],
			tickle: ["3E"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L10"],
			waterpulse: ["3M", "3L28"],
			waterspout: ["3L41"],
			whirlpool: ["3L19"],
		},
	},
	wailord: {
		inherit: true,
		learnset: {
			amnesia: ["3L52"],
			astonish: ["3L23"],
			attract: ["3M"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L59"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			mist: ["3L32"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L37"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollout: ["3L1"],
			secretpower: ["3M"],
			splash: ["3L1"],
			strength: ["3M"],
			surf: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M", "3L28"],
			waterspout: ["3L44"],
			whirlpool: ["3L19"],
		},
	},
	numel: {
		inherit: true,
		learnset: {
			amnesia: ["3L31"],
			attract: ["3M"],
			bodyslam: ["3E"],
			defensecurl: ["3E"],
			dig: ["3M"],
			doubleedge: ["3L49"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L35"],
			ember: ["3L11"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M", "3L41"],
			focusenergy: ["3L25"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			howl: ["3E"],
			magnitude: ["3L19"],
			overheat: ["3M"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			rollout: ["3E"],
			sandstorm: ["3M"],
			scaryface: ["3E"],
			secretpower: ["3M"],
			stomp: ["3E"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L29"],
			toxic: ["3M"],
		},
	},
	camerupt: {
		inherit: true,
		learnset: {
			amnesia: ["3L31"],
			attract: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L37"],
			ember: ["3L1"],
			eruption: ["3L45"],
			facade: ["3M"],
			fireblast: ["3M"],
			fissure: ["3L55"],
			flamethrower: ["3M"],
			focusenergy: ["3L25"],
			frustration: ["3M"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			magnitude: ["3L1"],
			overheat: ["3M"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rockslide: ["3L33"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L29"],
			toxic: ["3M"],
		},
	},
	torkoal: {
		inherit: true,
		learnset: {
			amnesia: ["3L40"],
			attract: ["3M"],
			bodyslam: ["3L20"],
			curse: ["3L7"],
			doubleteam: ["3M"],
			ember: ["3L1"],
			endure: ["3E"],
			eruption: ["3E"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L17"],
			flail: ["3L43"],
			flamethrower: ["3M", "3L30"],
			frustration: ["3M"],
			heatwave: ["3L46"],
			hiddenpower: ["3M"],
			irondefense: ["3L33"],
			irontail: ["3M"],
			overheat: ["3M"],
			protect: ["3M", "3L27"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			secretpower: ["3M"],
			sleeptalk: ["3E"],
			sludgebomb: ["3M"],
			smog: ["3L4"],
			smokescreen: ["3L14"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
			yawn: ["3E"],
		},
	},
	spoink: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bounce: ["3L43"],
			calmmind: ["3M"],
			confuseray: ["3L25"],
			doubleteam: ["3M"],
			extrasensory: ["3E"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			futuresight: ["3E"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			magiccoat: ["3L28"],
			odorsleuth: ["3L10"],
			protect: ["3M"],
			psybeam: ["3L16"],
			psychic: ["3M", "3L34"],
			psychup: ["3L19"],
			psywave: ["3L7"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M", "3L37"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			snore: ["3L37"],
			splash: ["3L1"],
			substitute: ["3E"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			trick: ["3E"],
		},
	},
	grumpig: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bounce: ["3L55"],
			calmmind: ["3M"],
			confuseray: ["3L25"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			lightscreen: ["3M"],
			magiccoat: ["3L28"],
			odorsleuth: ["3L1"],
			protect: ["3M"],
			psybeam: ["3L1"],
			psychic: ["3M", "3L37"],
			psychup: ["3L19"],
			psywave: ["3L1"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M", "3L43"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			snore: ["3L43"],
			splash: ["3L1"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
		},
	},
	spinda: {
		inherit: true,
		learnset: {
			assist: ["3E"],
			attract: ["3M"],
			batonpass: ["3E"],
			brickbreak: ["3M"],
			calmmind: ["3M"],
			dig: ["3M"],
			disable: ["3E"],
			dizzypunch: ["3L27"],
			doubleedge: ["3L45"],
			doubleteam: ["3M"],
			encore: ["3E"],
			facade: ["3M"],
			feintattack: ["3L12"],
			flail: ["3L49"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hypnosis: ["3L23"],
			protect: ["3M"],
			psybeam: ["3L16"],
			psychic: ["3M"],
			psychup: ["3L38"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			smellingsalts: ["3E"],
			snatch: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			teeterdance: ["3L34"],
			thief: ["3M"],
			thrash: ["3L56"],
			toxic: ["3M"],
			trick: ["3E"],
			uproar: ["3L5"],
			waterpulse: ["3M"],
			wish: ["3E"],
		},
	},
	trapinch: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L1"],
			crunch: ["3L33"],
			dig: ["3M", "3L41"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			feintattack: ["3L17"],
			focusenergy: ["3E"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			gust: ["3E"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L57"],
			protect: ["3M"],
			quickattack: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L9"],
			sandstorm: ["3M", "3L49"],
			sandtomb: ["3L25"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	vibrava: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L1"],
			crunch: ["3L33"],
			dig: ["3M"],
			doubleteam: ["3M"],
			dragonbreath: ["3L35"],
			earthquake: ["3M"],
			facade: ["3M"],
			feintattack: ["3L1"],
			fly: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L57"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L1"],
			sandstorm: ["3M", "3L49"],
			sandtomb: ["3L1"],
			screech: ["3L41"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	flygon: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L1"],
			crunch: ["3L33"],
			dig: ["3M"],
			doubleteam: ["3M"],
			dragonbreath: ["3L35"],
			dragonclaw: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			feintattack: ["3L1"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L65"],
			irontail: ["3M"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandattack: ["3L1"],
			sandstorm: ["3M", "3L53"],
			sandtomb: ["3L1"],
			screech: ["3L41"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	cacnea: {
		inherit: true,
		learnset: {
			absorb: ["3L5"],
			acid: ["3E"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cottonspore: ["3L41"],
			counter: ["3E"],
			cut: ["3M"],
			doubleteam: ["3M"],
			dynamicpunch: ["3E"],
			facade: ["3M"],
			feintattack: ["3L29"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			grasswhistle: ["3E"],
			growth: ["3L9"],
			hiddenpower: ["3M"],
			ingrain: ["3L25"],
			leechseed: ["3L13"],
			leer: ["3L1"],
			needlearm: ["3L37"],
			pinmissile: ["3L21"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L17"],
			sandstorm: ["3M", "3L45"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			spikes: ["3L33"],
			sunnyday: ["3M"],
			teeterdance: ["3E"],
			toxic: ["3M"],
		},
	},
	cacturne: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			attract: ["3M"],
			bulletseed: ["3M"],
			cottonspore: ["3L47"],
			cut: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			feintattack: ["3L29"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growth: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			ingrain: ["3L25"],
			leechseed: ["3L13"],
			leer: ["3L1"],
			needlearm: ["3L41"],
			pinmissile: ["3L21"],
			poisonsting: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			sandattack: ["3L17"],
			sandstorm: ["3M", "3L53"],
			secretpower: ["3M"],
			solarbeam: ["3M"],
			spikes: ["3L35"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	swablu: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			agility: ["3E"],
			astonish: ["3L8"],
			attract: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L18"],
			growl: ["3L1"],
			haze: ["3E"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			mirrormove: ["3L38"],
			mist: ["3L28"],
			peck: ["3L1"],
			perishsong: ["3L48"],
			protect: ["3M"],
			pursuit: ["3E"],
			rage: ["3E"],
			raindance: ["3M"],
			refresh: ["3L41"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3L21"],
			secretpower: ["3M"],
			sing: ["3L11"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			takedown: ["3L31"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	altaria: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			astonish: ["3L1"],
			attract: ["3M"],
			doubleteam: ["3M"],
			dragonbreath: ["3L35"],
			dragonclaw: ["3M"],
			dragondance: ["3L40"],
			earthquake: ["3M"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			furyattack: ["3L18"],
			growl: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			mist: ["3L28"],
			peck: ["3L1"],
			perishsong: ["3L54"],
			protect: ["3M"],
			raindance: ["3M"],
			refresh: ["3L45"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M", "3L21"],
			secretpower: ["3M"],
			sing: ["3L1"],
			skyattack: ["3L59"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			takedown: ["3L31"],
			thief: ["3M"],
			toxic: ["3M"],
		},
	},
	zangoose: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			counter: ["3E"],
			crushclaw: ["3L31"],
			curse: ["3E"],
			detect: ["3L46"],
			dig: ["3M"],
			doublekick: ["3E"],
			doubleteam: ["3M"],
			facade: ["3M"],
			falseswipe: ["3L55"],
			fireblast: ["3M"],
			flail: ["3E"],
			flamethrower: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furycutter: ["3L13"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L4"],
			protect: ["3M"],
			pursuit: ["3L25"],
			quickattack: ["3L7"],
			raindance: ["3M"],
			razorwind: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M", "3E"],
			rocksmash: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slash: ["3L19"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swordsdance: ["3L10"],
			taunt: ["3M", "3L37"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	seviper: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L10"],
			bodyslam: ["3E"],
			crunch: ["3L28"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			glare: ["3L25"],
			haze: ["3L43"],
			hiddenpower: ["3M"],
			irontail: ["3M"],
			lick: ["3L7"],
			poisonfang: ["3L34"],
			poisontail: ["3L16"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			screech: ["3L19"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			snatch: ["3M"],
			spitup: ["3E"],
			stockpile: ["3E"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swagger: ["3L37"],
			swallow: ["3E"],
			taunt: ["3M"],
			thief: ["3M"],
			toxic: ["3M"],
			wrap: ["3L1"],
		},
	},
	lunatone: {
		inherit: true,
		learnset: {
			calmmind: ["3M"],
			confusion: ["3L7"],
			cosmicpower: ["3L31"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			explosion: ["3L49"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L43"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			hypnosis: ["3L19"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			protect: ["3M"],
			psychic: ["3M", "3L37"],
			psywave: ["3L25"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockthrow: ["3L13"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
		},
	},
	solrock: {
		inherit: true,
		learnset: {
			calmmind: ["3M"],
			confusion: ["3L7"],
			cosmicpower: ["3L31"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			explosion: ["3L49"],
			facade: ["3M"],
			fireblast: ["3M"],
			firespin: ["3L19"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			lightscreen: ["3M"],
			overheat: ["3M"],
			protect: ["3M"],
			psychic: ["3M"],
			psywave: ["3L25"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3L37"],
			rockthrow: ["3L13"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			solarbeam: ["3M", "3L43"],
			sunnyday: ["3M"],
			tackle: ["3L1"],
			toxic: ["3M"],
		},
	},
	barboach: {
		inherit: true,
		learnset: {
			amnesia: ["3L21"],
			attract: ["3M"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L31"],
			facade: ["3M"],
			fissure: ["3L41"],
			frustration: ["3M"],
			futuresight: ["3L36"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			magnitude: ["3L16"],
			mudslap: ["3L1"],
			mudsport: ["3L6"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L26"],
			return: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			snore: ["3L26"],
			spark: ["3E"],
			surf: ["3M"],
			thrash: ["3E"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L11"],
			waterpulse: ["3M"],
			watersport: ["3L6"],
			whirlpool: ["3E"],
		},
	},
	whiscash: {
		inherit: true,
		learnset: {
			amnesia: ["3L21"],
			attract: ["3M"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M", "3L36"],
			facade: ["3M"],
			fissure: ["3L56"],
			frustration: ["3M"],
			futuresight: ["3L46"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			magnitude: ["3L16"],
			mudslap: ["3L1"],
			mudsport: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L26"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			snore: ["3L26"],
			strength: ["3M"],
			surf: ["3M"],
			tickle: ["3L1"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L11"],
			waterpulse: ["3M"],
			watersport: ["3L1"],
		},
	},
	corphish: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			ancientpower: ["3E"],
			attract: ["3M"],
			blizzard: ["3M"],
			bodyslam: ["3E"],
			brickbreak: ["3M"],
			bubble: ["3L1"],
			bubblebeam: ["3L19"],
			crabhammer: ["3L34"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			endeavor: ["3E"],
			facade: ["3M"],
			frustration: ["3M"],
			guillotine: ["3L44"],
			hail: ["3M"],
			harden: ["3L7"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			knockoff: ["3L25"],
			leer: ["3L13"],
			mudsport: ["3E"],
			protect: ["3M", "3L22"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			surf: ["3M"],
			swordsdance: ["3L37"],
			taunt: ["3M", "3L31"],
			toxic: ["3M"],
			visegrip: ["3L10"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	crawdaunt: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			bubble: ["3L1"],
			bubblebeam: ["3L19"],
			crabhammer: ["3L38"],
			cut: ["3M"],
			dig: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			guillotine: ["3L52"],
			hail: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			knockoff: ["3L25"],
			leer: ["3L1"],
			protect: ["3M", "3L22"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			surf: ["3M"],
			swordsdance: ["3L43"],
			taunt: ["3M", "3L33"],
			toxic: ["3M"],
			visegrip: ["3L1"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	baltoy: {
		inherit: true,
		learnset: {
			ancientpower: ["3L25"],
			confusion: ["3L1"],
			cosmicpower: ["3L37"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			explosion: ["3L45"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			harden: ["3L3"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			mudslap: ["3L7"],
			protect: ["3M"],
			psybeam: ["3L11"],
			psychic: ["3M"],
			raindance: ["3M"],
			rapidspin: ["3L5"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocktomb: ["3M", "3L15"],
			sandstorm: ["3M", "3L31"],
			secretpower: ["3M"],
			selfdestruct: ["3L19"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			solarbeam: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	claydol: {
		inherit: true,
		learnset: {
			ancientpower: ["3L25"],
			confusion: ["3L1"],
			cosmicpower: ["3L42"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			explosion: ["3L55"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L36"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			mudslap: ["3L7"],
			protect: ["3M"],
			psybeam: ["3L11"],
			psychic: ["3M"],
			raindance: ["3M"],
			rapidspin: ["3L1"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M", "3L15"],
			sandstorm: ["3M", "3L31"],
			secretpower: ["3M"],
			selfdestruct: ["3L19"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			teleport: ["3L1"],
			toxic: ["3M"],
		},
	},
	lileep: {
		inherit: true,
		learnset: {
			acid: ["3L15"],
			amnesia: ["3L36"],
			ancientpower: ["3L43"],
			astonish: ["3L1"],
			attract: ["3M"],
			barrier: ["3E"],
			bulletseed: ["3M"],
			confuseray: ["3L29"],
			constrict: ["3L8"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			ingrain: ["3L22"],
			mirrorcoat: ["3E"],
			protect: ["3M"],
			recover: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			rockslide: ["3E"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			spitup: ["3L50"],
			stockpile: ["3L50"],
			sunnyday: ["3M"],
			swallow: ["3L50"],
			toxic: ["3M"],
		},
	},
	cradily: {
		inherit: true,
		learnset: {
			acid: ["3L1"],
			amnesia: ["3L36"],
			ancientpower: ["3L48"],
			astonish: ["3L1"],
			attract: ["3M"],
			bulletseed: ["3M"],
			confuseray: ["3L29"],
			constrict: ["3L1"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			ingrain: ["3L1"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			sludgebomb: ["3M"],
			solarbeam: ["3M"],
			spitup: ["3L60"],
			stockpile: ["3L60"],
			strength: ["3M"],
			sunnyday: ["3M"],
			swallow: ["3L60"],
			toxic: ["3M"],
		},
	},
	anorith: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			ancientpower: ["3L37"],
			attract: ["3M"],
			brickbreak: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			furycutter: ["3L43"],
			harden: ["3L7"],
			hiddenpower: ["3M"],
			knockoff: ["3E"],
			metalclaw: ["3L25"],
			mudsport: ["3L13"],
			protect: ["3M", "3L31"],
			rest: ["3M"],
			return: ["3M"],
			rockblast: ["3L55"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			slash: ["3L49"],
			sunnyday: ["3M"],
			swordsdance: ["3E"],
			toxic: ["3M"],
			watergun: ["3L19"],
			waterpulse: ["3M"],
		},
	},
	armaldo: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			ancientpower: ["3L37"],
			attract: ["3M"],
			brickbreak: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			furycutter: ["3L46"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			metalclaw: ["3L25"],
			mudsport: ["3L1"],
			protect: ["3M", "3L31"],
			rest: ["3M"],
			return: ["3M"],
			rockblast: ["3L64"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			slash: ["3L55"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	feebas: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			confuseray: ["3E"],
			dive: ["3M"],
			doubleteam: ["3M"],
			dragonbreath: ["3E"],
			facade: ["3M"],
			flail: ["3L30"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hypnosis: ["3E"],
			icebeam: ["3M"],
			lightscreen: ["3E"],
			mirrorcoat: ["3E"],
			mudsport: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			splash: ["3L1"],
			surf: ["3M"],
			tackle: ["3L15"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	milotic: {
		inherit: true,
		learnset: {
			attract: ["3M", "3L45"],
			blizzard: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L40"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			protect: ["3M"],
			raindance: ["3M", "3L35"],
			recover: ["3L30"],
			refresh: ["3L15"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3L50"],
			secretpower: ["3M"],
			surf: ["3M"],
			toxic: ["3M"],
			twister: ["3L25"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M", "3L20"],
			watersport: ["3L10"],
			wrap: ["3L5"],
		},
	},
	castform: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			blizzard: ["3M"],
			doubleteam: ["3M"],
			ember: ["3L10"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			futuresight: ["3E"],
			hail: ["3M", "3L20"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			powdersnow: ["3L10"],
			protect: ["3M"],
			psychup: ["3E"],
			raindance: ["3M", "3L20"],
			rest: ["3M"],
			return: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			sunnyday: ["3M", "3L20"],
			tackle: ["3L1"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			watergun: ["3L10"],
			waterpulse: ["3M"],
			weatherball: ["3L30"],
		},
	},
	kecleon: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			ancientpower: ["3L49"],
			astonish: ["3L1"],
			attract: ["3M"],
			bind: ["3L4"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			cut: ["3M"],
			dig: ["3M"],
			disable: ["3E"],
			doubleteam: ["3M"],
			facade: ["3M"],
			feintattack: ["3L7"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			furyswipes: ["3L12"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			lick: ["3L1"],
			magiccoat: ["3E"],
			protect: ["3M"],
			psybeam: ["3L17"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scratch: ["3L1"],
			screech: ["3L24"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			slash: ["3L31"],
			snatch: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			substitute: ["3L40"],
			sunnyday: ["3M"],
			tailwhip: ["3L1"],
			thief: ["3M", "3L1"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			trick: ["3E"],
			waterpulse: ["3M"],
		},
	},
	shuppet: {
		inherit: true,
		learnset: {
			astonish: ["3E"],
			attract: ["3M"],
			calmmind: ["3M"],
			curse: ["3L20"],
			destinybond: ["3E"],
			disable: ["3E"],
			doubleteam: ["3M"],
			facade: ["3M"],
			feintattack: ["3L37"],
			flash: ["3M"],
			foresight: ["3E"],
			frustration: ["3M"],
			grudge: ["3L56"],
			hiddenpower: ["3M"],
			imprison: ["3E"],
			knockoff: ["3L1"],
			nightshade: ["3L13"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L8"],
			secretpower: ["3M"],
			shadowball: ["3M", "3L44"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M", "3L49"],
			spite: ["3L25"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			willowisp: ["3L32"],
		},
	},
	banette: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			calmmind: ["3M"],
			curse: ["3L1"],
			doubleteam: ["3M"],
			facade: ["3M"],
			feintattack: ["3L39"],
			flash: ["3M"],
			frustration: ["3M"],
			grudge: ["3L64"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			knockoff: ["3L1"],
			nightshade: ["3L1"],
			protect: ["3M"],
			psychic: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			screech: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M", "3L48"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M", "3L55"],
			spite: ["3L25"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			willowisp: ["3L32"],
		},
	},
	duskull: {
		inherit: true,
		learnset: {
			astonish: ["3L16"],
			attract: ["3M"],
			blizzard: ["3M"],
			calmmind: ["3M"],
			confuseray: ["3L23"],
			curse: ["3L34"],
			destinybond: ["3E"],
			disable: ["3L5"],
			doubleteam: ["3M"],
			facade: ["3M"],
			feintattack: ["3E"],
			flash: ["3M"],
			foresight: ["3L12"],
			frustration: ["3M"],
			futuresight: ["3L49"],
			grudge: ["3E"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			imprison: ["3E"],
			leer: ["3L1"],
			meanlook: ["3L45"],
			memento: ["3E"],
			nightshade: ["3L1"],
			protect: ["3M"],
			psychic: ["3M"],
			pursuit: ["3L27"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			willowisp: ["3L38"],
		},
	},
	dusclops: {
		inherit: true,
		learnset: {
			astonish: ["3L16"],
			attract: ["3M"],
			bind: ["3L1"],
			blizzard: ["3M"],
			calmmind: ["3M"],
			confuseray: ["3L23"],
			curse: ["3L34"],
			disable: ["3L1"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			focuspunch: ["3M"],
			foresight: ["3L12"],
			frustration: ["3M"],
			futuresight: ["3L58"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			leer: ["3L1"],
			meanlook: ["3L51"],
			nightshade: ["3L1"],
			protect: ["3M"],
			psychic: ["3M"],
			pursuit: ["3L27"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shadowpunch: ["3L37"],
			skillswap: ["3M"],
			snatch: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			taunt: ["3M"],
			thief: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			willowisp: ["3L41"],
		},
	},
	tropius: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bodyslam: ["3L37"],
			bulletseed: ["3M"],
			cut: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			gigadrain: ["3M"],
			growth: ["3L7"],
			gust: ["3L1"],
			headbutt: ["3E"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			leechseed: ["3E"],
			leer: ["3L1"],
			magicalleaf: ["3L31"],
			naturepower: ["3E"],
			protect: ["3M"],
			razorleaf: ["3L11"],
			razorwind: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			slam: ["3E"],
			solarbeam: ["3M", "3L41"],
			steelwing: ["3M"],
			stomp: ["3L17"],
			strength: ["3M"],
			sunnyday: ["3M"],
			sweetscent: ["3L21"],
			synthesis: ["3L47"],
			toxic: ["3M"],
			whirlwind: ["3L27"],
		},
	},
	chimecho: {
		learnset: {
			astonish: ["3L9"],
			attract: ["3M"],
			calmmind: ["3M"],
			confusion: ["3L14"],
			curse: ["3E"],
			disable: ["3E"],
			doubleedge: ["3L33"],
			doubleteam: ["3M"],
			dreameater: ["3E"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			growl: ["3L6"],
			healbell: ["3L38"],
			hiddenpower: ["3M"],
			hypnosis: ["3E"],
			lightscreen: ["3M"],
			protect: ["3M"],
			psychic: ["3M", "3L46"],
			psywave: ["3L30"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3L41"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			skillswap: ["3M"],
			snatch: ["3M"],
			sunnyday: ["3M"],
			takedown: ["3L17"],
			taunt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			uproar: ["3L22"],
			wrap: ["3L1"],
			yawn: ["3L25"],
		},
	},
	absol: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			batonpass: ["3E"],
			bite: ["3L21"],
			blizzard: ["3M"],
			calmmind: ["3M"],
			curse: ["3E"],
			cut: ["3M"],
			doubleedge: ["3E"],
			doubleteam: ["3M", "3L31"],
			facade: ["3M"],
			feintattack: ["3E"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			futuresight: ["3L41"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L5"],
			magiccoat: ["3E"],
			perishsong: ["3L46"],
			protect: ["3M"],
			quickattack: ["3L13"],
			raindance: ["3M"],
			razorwind: ["3L17"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			scratch: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			slash: ["3L36"],
			snatch: ["3M"],
			spite: ["3S0"],
			strength: ["3M"],
			substitute: ["3E"],
			sunnyday: ["3M"],
			swordsdance: ["3L26"],
			taunt: ["3M", "3L9"],
			thief: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
			wish: ["3S1"],
		},
	},
	snorunt: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L10"],
			blizzard: ["3M", "3L43"],
			block: ["3E"],
			crunch: ["3L28"],
			doubleteam: ["3M", "3L7"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M", "3L37"],
			headbutt: ["3L19"],
			hiddenpower: ["3M"],
			icebeam: ["3M", "3L34"],
			icywind: ["3L16"],
			leer: ["3L1"],
			lightscreen: ["3M"],
			powdersnow: ["3L1"],
			protect: ["3M", "3L25"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			spikes: ["3E"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	glalie: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			bite: ["3L1"],
			blizzard: ["3M", "3L53"],
			crunch: ["3L28"],
			doubleteam: ["3M", "3L1"],
			earthquake: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hail: ["3M", "3L42"],
			headbutt: ["3L19"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M", "3L34"],
			icywind: ["3L16"],
			leer: ["3L1"],
			lightscreen: ["3M"],
			powdersnow: ["3L1"],
			protect: ["3M", "3L25"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sheercold: ["3L61"],
			taunt: ["3M"],
			torment: ["3M"],
			toxic: ["3M"],
			waterpulse: ["3M"],
		},
	},
	spheal: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			aurorabeam: ["3L25"],
			blizzard: ["3M", "3L43"],
			bodyslam: ["3L19"],
			curse: ["3E"],
			dive: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			encore: ["3L7"],
			facade: ["3M"],
			fissure: ["3E"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M", "3L31"],
			hiddenpower: ["3M"],
			iceball: ["3L13"],
			icebeam: ["3M"],
			irontail: ["3M"],
			powdersnow: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L37"],
			return: ["3M"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			sheercold: ["3L49"],
			snore: ["3L37"],
			spitup: ["3E"],
			stockpile: ["3E"],
			strength: ["3M"],
			surf: ["3M"],
			swallow: ["3E"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
			watersport: ["3E"],
			yawn: ["3E"],
		},
	},
	sealeo: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			aurorabeam: ["3L25"],
			blizzard: ["3M", "3L47"],
			bodyslam: ["3L19"],
			dive: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			encore: ["3L1"],
			facade: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M", "3L31"],
			hiddenpower: ["3M"],
			iceball: ["3L13"],
			icebeam: ["3M"],
			irontail: ["3M"],
			powdersnow: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L39"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			sheercold: ["3L55"],
			snore: ["3L39"],
			strength: ["3M"],
			surf: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	walrein: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			aurorabeam: ["3L25"],
			blizzard: ["3M", "3L50"],
			bodyslam: ["3L19"],
			dive: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			encore: ["3L1"],
			facade: ["3M"],
			frustration: ["3M"],
			growl: ["3L1"],
			hail: ["3M", "3L31"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			iceball: ["3L13"],
			icebeam: ["3M"],
			irontail: ["3M"],
			powdersnow: ["3L1"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L39"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			secretpower: ["3M"],
			sheercold: ["3L61"],
			snore: ["3L39"],
			strength: ["3M"],
			surf: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
		},
	},
	clamperl: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			barrier: ["3E"],
			blizzard: ["3M"],
			bodyslam: ["3E"],
			clamp: ["3L1"],
			confuseray: ["3E"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			irondefense: ["3L1"],
			mudsport: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			refresh: ["3E"],
			rest: ["3M"],
			return: ["3M"],
			secretpower: ["3M"],
			supersonic: ["3E"],
			surf: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L1"],
			waterpulse: ["3M"],
			whirlpool: ["3L1"],
		},
	},
	huntail: {
		inherit: true,
		learnset: {
			attract: ["3M"],
			batonpass: ["3L43"],
			bite: ["3L8"],
			blizzard: ["3M"],
			crunch: ["3L36"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L50"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L29"],
			screech: ["3L15"],
			secretpower: ["3M"],
			snatch: ["3M"],
			surf: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M", "3L22"],
			whirlpool: ["3L1"],
		},
	},
	gorebyss: {
		inherit: true,
		learnset: {
			agility: ["3L15"],
			amnesia: ["3L29"],
			attract: ["3M"],
			batonpass: ["3L43"],
			blizzard: ["3M"],
			confusion: ["3L8"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L50"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			protect: ["3M"],
			psychic: ["3M", "3L36"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			surf: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M", "3L22"],
			whirlpool: ["3L1"],
		},
	},
	relicanth: {
		inherit: true,
		learnset: {
			amnesia: ["3E"],
			ancientpower: ["3L43"],
			attract: ["3M"],
			blizzard: ["3M"],
			calmmind: ["3M"],
			dive: ["3M"],
			doubleedge: ["3L57"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			harden: ["3L1"],
			hiddenpower: ["3M"],
			hydropump: ["3L64"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			magnitude: ["3E"],
			mudsport: ["3L36"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L50"],
			return: ["3M"],
			rockslide: ["3E"],
			rocksmash: ["3M"],
			rocktomb: ["3M", "3L15"],
			safeguard: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			skullbash: ["3E"],
			sleeptalk: ["3E"],
			surf: ["3M"],
			tackle: ["3L1"],
			takedown: ["3L29"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L8"],
			waterpulse: ["3M"],
			watersport: ["3E"],
			yawn: ["3L22"],
		},
	},
	luvdisc: {
		inherit: true,
		learnset: {
			agility: ["3L16"],
			attract: ["3M", "3L28"],
			blizzard: ["3M"],
			charm: ["3L4"],
			dive: ["3M"],
			doubleteam: ["3M"],
			facade: ["3M"],
			flail: ["3L40"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			icebeam: ["3M"],
			mudsport: ["3E"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			safeguard: ["3M", "3L48"],
			secretpower: ["3M"],
			splash: ["3E"],
			supersonic: ["3E"],
			surf: ["3M"],
			sweetkiss: ["3L36"],
			tackle: ["3L1"],
			takedown: ["3L24"],
			toxic: ["3M"],
			waterfall: ["3M"],
			watergun: ["3L12"],
			waterpulse: ["3M"],
			watersport: ["3E"],
		},
	},
	bagon: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bite: ["3L5"],
			brickbreak: ["3M"],
			crunch: ["3L41"],
			cut: ["3M"],
			doubleedge: ["3L53"],
			doubleteam: ["3M"],
			dragonbreath: ["3L33"],
			dragonclaw: ["3M", "3L49"],
			dragondance: ["3E"],
			dragonrage: ["3E"],
			ember: ["3L25"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L21"],
			frustration: ["3M"],
			headbutt: ["3L17"],
			hiddenpower: ["3M"],
			hydropump: ["3E"],
			irondefense: ["3S0"],
			leer: ["3L9"],
			protect: ["3M"],
			rage: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L37"],
			secretpower: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			thrash: ["3E"],
			toxic: ["3M"],
			twister: ["3E"],
			spite: ["3S1"],
			wish: ["3S1"],
		},
	},
	shelgon: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bite: ["3L1"],
			brickbreak: ["3M"],
			crunch: ["3L56"],
			cut: ["3M"],
			doubleedge: ["3L78"],
			doubleteam: ["3M"],
			dragonbreath: ["3L38"],
			dragonclaw: ["3M", "3L69"],
			ember: ["3L25"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			focusenergy: ["3L21"],
			frustration: ["3M"],
			headbutt: ["3L1"],
			hiddenpower: ["3M"],
			leer: ["3L1"],
			protect: ["3M", "3L30"],
			rage: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L47"],
			secretpower: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	salamence: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			bite: ["3L1"],
			brickbreak: ["3M"],
			crunch: ["3L61"],
			cut: ["3M"],
			doubleedge: ["3L93"],
			doubleteam: ["3M"],
			dragonbreath: ["3L38"],
			dragonclaw: ["3M", "3L79"],
			earthquake: ["3M"],
			ember: ["3L25"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			fly: ["3M", "3L50"],
			focusenergy: ["3L21"],
			frustration: ["3M"],
			headbutt: ["3L1"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			leer: ["3L1"],
			protect: ["3M", "3L30"],
			rage: ["3L1"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			scaryface: ["3L47"],
			secretpower: ["3M"],
			steelwing: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			toxic: ["3M"],
		},
	},
	beldum: {
		inherit: true,
		learnset: {
			takedown: ["3L1"],
		},
	},
	metang: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			agility: ["3L56"],
			brickbreak: ["3M"],
			confusion: ["3L20"],
			cut: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L62"],
			irondefense: ["3L44"],
			lightscreen: ["3M"],
			metalclaw: ["3L20"],
			meteormash: ["3L50"],
			protect: ["3M"],
			psychic: ["3M", "3L38"],
			pursuit: ["3L32"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L26"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			takedown: ["3L1"],
			toxic: ["3M"],
		},
	},
	metagross: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			agility: ["3L66"],
			brickbreak: ["3M"],
			confusion: ["3L1"],
			cut: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L77"],
			irondefense: ["3L44"],
			lightscreen: ["3M"],
			metalclaw: ["3L1"],
			meteormash: ["3L55"],
			protect: ["3M"],
			psychic: ["3M", "3L38"],
			pursuit: ["3L32"],
			raindance: ["3M"],
			reflect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L1"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			sludgebomb: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			takedown: ["3L1"],
			toxic: ["3M"],
		},
	},
	regirock: {
		inherit: true,
		learnset: {
			ancientpower: ["3L33"],
			brickbreak: ["3M"],
			curse: ["3L17"],
			dig: ["3M"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			explosion: ["3L1"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L65"],
			irondefense: ["3L41"],
			lockon: ["3L57"],
			protect: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rockthrow: ["3L9"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			superpower: ["3L25"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			zapcannon: ["3L49"],
		},
	},
	regice: {
		inherit: true,
		learnset: {
			amnesia: ["3L41"],
			ancientpower: ["3L33"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			curse: ["3L17"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			explosion: ["3L1"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L65"],
			icebeam: ["3M"],
			icywind: ["3L9"],
			lockon: ["3L57"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			safeguard: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			strength: ["3M"],
			superpower: ["3L25"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			zapcannon: ["3L49"],
		},
	},
	registeel: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			amnesia: ["3L41"],
			ancientpower: ["3L33"],
			brickbreak: ["3M"],
			curse: ["3L17"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			explosion: ["3L1"],
			facade: ["3M"],
			focuspunch: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L65"],
			irondefense: ["3L41"],
			lockon: ["3L57"],
			metalclaw: ["3L9"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M"],
			return: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			superpower: ["3L25"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			zapcannon: ["3L49"],
		},
	},
	latias: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			calmmind: ["3M"],
			charm: ["3L50"],
			cut: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			dragonbreath: ["3L20"],
			dragonclaw: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			helpinghand: ["3L10"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			mistball: ["3L35"],
			protect: ["3M"],
			psychic: ["3M", "3L40"],
			psywave: ["3L1"],
			raindance: ["3M"],
			recover: ["3L45"],
			reflect: ["3M"],
			refresh: ["3L30"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			safeguard: ["3M", "3L15"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
			watersport: ["3L25"],
			wish: ["3L5"],
		},
	},
	latios: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			attract: ["3M"],
			calmmind: ["3M"],
			cut: ["3M"],
			dive: ["3M"],
			doubleteam: ["3M"],
			dragonbreath: ["3L20"],
			dragonclaw: ["3M"],
			dragondance: ["3L50"],
			earthquake: ["3M"],
			facade: ["3M"],
			flash: ["3M"],
			fly: ["3M"],
			frustration: ["3M"],
			helpinghand: ["3L10"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			icebeam: ["3M"],
			lightscreen: ["3M"],
			lusterpurge: ["3L35"],
			memento: ["3L5"],
			protect: ["3M", "3L25"],
			psychic: ["3M", "3L40"],
			psywave: ["3L1"],
			raindance: ["3M"],
			recover: ["3L45"],
			reflect: ["3M"],
			refresh: ["3L30"],
			rest: ["3M"],
			return: ["3M"],
			roar: ["3M"],
			safeguard: ["3M", "3L15"],
			sandstorm: ["3M"],
			secretpower: ["3M"],
			shadowball: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			steelwing: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
	kyogre: {
		inherit: true,
		learnset: {
			ancientpower: ["3L15"],
			blizzard: ["3M"],
			bodyslam: ["3L20"],
			brickbreak: ["3M"],
			calmmind: ["3M", "3L30"],
			dive: ["3M"],
			doubleedge: ["3L65"],
			doubleteam: ["3M"],
			earthquake: ["3M"],
			facade: ["3M"],
			frustration: ["3M"],
			hail: ["3M"],
			hiddenpower: ["3M"],
			hydropump: ["3L45"],
			hyperbeam: ["3M"],
			icebeam: ["3M", "3L35"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L50"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			scaryface: ["3L5"],
			secretpower: ["3M"],
			sheercold: ["3L60"],
			shockwave: ["3M"],
			strength: ["3M"],
			surf: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			waterfall: ["3M"],
			waterpulse: ["3M", "3L1"],
			waterspout: ["3L75"],
		},
	},
	groudon: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			ancientpower: ["3L15"],
			brickbreak: ["3M"],
			bulkup: ["3M", "3L30"],
			cut: ["3M"],
			dig: ["3M"],
			doubleteam: ["3M"],
			dragonclaw: ["3M"],
			earthquake: ["3M", "3L35"],
			eruption: ["3L75"],
			facade: ["3M"],
			fireblast: ["3M", "3L45"],
			fissure: ["3L60"],
			flamethrower: ["3M"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M"],
			irontail: ["3M"],
			mudshot: ["3L1"],
			overheat: ["3M"],
			protect: ["3M"],
			rest: ["3M", "3L50"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			rocktomb: ["3M"],
			safeguard: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L5"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			slash: ["3L20"],
			solarbeam: ["3M", "3L65"],
			strength: ["3M"],
			sunnyday: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
		},
	},
	rayquaza: {
		inherit: true,
		learnset: {
			aerialace: ["3M"],
			ancientpower: ["3L15"],
			blizzard: ["3M"],
			brickbreak: ["3M"],
			bulkup: ["3M"],
			crunch: ["3L35"],
			dive: ["3M"],
			doubleteam: ["3M"],
			dragonclaw: ["3M", "3L20"],
			dragondance: ["3L30"],
			earthquake: ["3M"],
			extremespeed: ["3L60"],
			facade: ["3M"],
			fireblast: ["3M"],
			flamethrower: ["3M"],
			fly: ["3M", "3L45"],
			frustration: ["3M"],
			hiddenpower: ["3M"],
			hyperbeam: ["3M", "3L75"],
			icebeam: ["3M"],
			irontail: ["3M"],
			outrage: ["3L65"],
			overheat: ["3M"],
			protect: ["3M"],
			raindance: ["3M"],
			rest: ["3M", "3L50"],
			return: ["3M"],
			roar: ["3M"],
			rocksmash: ["3M"],
			sandstorm: ["3M"],
			scaryface: ["3L5"],
			secretpower: ["3M"],
			shockwave: ["3M"],
			solarbeam: ["3M"],
			strength: ["3M"],
			sunnyday: ["3M"],
			surf: ["3M"],
			thunder: ["3M"],
			thunderbolt: ["3M"],
			toxic: ["3M"],
			twister: ["3L1"],
			waterfall: ["3M"],
			waterpulse: ["3M"],
		},
	},
};
